import { capitalCase } from 'change-case'
import { useState, useEffect, useRef, useCallback, forwardRef, useMemo } from 'react'
// import { io } from 'socket.io-client' // OLD
import createAppSocket from 'src/Helpers/createSocket'
import {
  Groups,
  CheckCircle,
  Error,
  Attachment,
  MoreVert,
  Print,
  List,
  ViewList,
  ViewModule,
  UploadFileSharp,
  Description,
  Notes,
  Visibility,
} from '@material-ui/icons'
import Tooltip from '@mui/material/Tooltip'
// material
import {
  Container,
  Tab,
  Box,
  Tabs,
  Stack,
  Button,
  Menu,
  Typography,
  MenuItem,
  TextField,
  Card,
  Grid,
  Slider as Sliderw,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardContent,
  ImageList,
  useMediaQuery,
  ImageListItem,
  ImageListItemBar,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  Backdrop,
  IconButton,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core'
import {
  alpha,
  experimentalStyled as styled,
  useTheme,
} from '@material-ui/core/styles'
// components
import Tasks from '../../components/projects/viewProjects/Tasks'
import Members from '../../components/projects/viewProjects/Members'
import ViewRequest from 'src/components/_dashboard/official-request/ViewRequest'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT, REST_API_IO, FacilityTypes } from 'src/constants/Defaultvalues'
import { useParams, useNavigate, useLocation } from 'react-router'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import Label from 'src/components/Label'
import Scrollbar from 'src/components/Scrollbar'
import moment from 'moment'
import AddTask from 'src/components/projects/AddTask'
import AddMember from 'src/components/projects/AddMember'
import AddProject from 'src/components/_dashboard/blog/AddProject'
import { useSnackbar } from 'notistack'
import RevertStatusDialog from 'src/components/revert/RevertStatusDialog'
import { buildRevertStatusOptions, getRevertOptionKey } from 'src/utils/revertStatusOptions'
import ReactToPrint from 'react-to-print'
import { KeyboardBackspaceOutlined } from '@material-ui/icons'
import { Link as RouterLink } from 'react-router-dom'
import { PATH_DASHBOARD, ROOTS_PCB } from '../../routes/paths'
import { PRESERVE_WHITESPACE_SX } from 'src/utils/preserveWhitespace'
import { CarouselControlsPaging1 } from '../../components/carousel'
import Slider from 'react-slick'
import { LoadingButton } from '@material-ui/lab'
import { storage } from 'src/firebase/firebase'
import {
  deleteObject,
  getDownloadURL,
  uploadBytesResumable,
  ref as imageref,
} from '@firebase/storage'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import ProjectAttachment from 'src/components/_dashboard/blog/ProjectAttachment'
import { set } from 'lodash'
import Locations from 'src/components/_dashboard/official-request/Locations'
import ConfirmationPopup from 'src/components/confirmationPopup'
import LoadingScreen from 'src/components/LoadingScreen'
import JobNotesMessageBoard from 'src/components/_dashboard/user/profile/JobNotesMessageBoard'
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow'
import { SalesOrderNewBadgeList } from 'src/components/_dashboard/official-request/SalesOrderNewBadge'
import useJobNoteTabUnread from 'src/hooks/useJobNoteTabUnread'
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import { UploadMultiFile } from 'src/components/upload'
import { supabase } from '../../supabase/supabaseClient'
import { Slide } from '@mui/material'

const ClockInTransition = forwardRef(function ClockInTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
// ----------------------------------------------------------------------

// let  option = [
//   { id: 0, value: 'Inactive' },
//   { id: 1, value: 'New' },
//   { id: 2, value: 'Open' },
//   { id: 3, value: 'Completed' },
//   { id: 4, value: 'In Testing' },
//   { id: 5, value: 'Accepted' },
//   { id: 6, value: 'Rejected' },
//   { id: 7, value: 'Verified' },
//   { id: 6, value: 'Reopen' },
// ]
let option = [
  // { id: 0, value: 'Inactive' },
  { id: 1, value: 'New' },
  { id: 2, value: 'Inprogress' },
  { id: 3, value: 'Completed' },
  { id: 4, value: 'In Testing' },
  // { id: 5, value: 'Active' },
  // { id: 6, value: 'Rejected' },
  // { id: 7, value: 'Hold' },
  // { id: 6, value: 'Reopen' },
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#0275d8',
  '#008000',
  '#f0ad4e',
  '#5cb85c',
  '#c9302c',
  '#5cb85c',
  '#5bc0de',
  '#c9302c',
]

const PRODUCTS = [
  { name: 'Air Max 97', image: `/static/mock-images/products/product_1.jpg` },
  { name: 'PierBurger', image: `/static/mock-images/products/product_2.jpg` },
  {
    name: 'BLACK LIVE MATTERS',
    image: `/static/mock-images/products/product_3.jpg`,
  },
  { name: 'Britex', image: `/static/mock-images/products/product_4.jpg` },
  {
    name: 'KEG Steak House Bar',
    image: `/static/mock-images/products/product_5.jpg`,
  },
]

const CarouselImgStyle = styled('img')(({ theme }) => ({
  width: '100%',
  height: 280,
  objectFit: 'cover',
  [theme.breakpoints.up('xl')]: {
    height: 320,
  },
}))
const APPROVED_DESIGN_EXTENSIONS = ['eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps', 'indd', 'indt'];
const isApprovedDesignPreview = (row) => {
  if (row?.approved !== 1) return false;
  const fileType = (row?.file_type || '').toLowerCase();
  if (fileType.startsWith('image/') || fileType === 'img' || fileType === 'image') return true;
  const nameSource = row?.name || row?.file_url || '';
  const extension = nameSource.split('?')[0].split('.').pop()?.toLowerCase() || '';
  return APPROVED_DESIGN_EXTENSIONS.includes(extension);
};
const isGoogleViewerDesign = (row) => {
  const nameSource = row?.name || row?.file_url || '';
  const extension = nameSource.split('?')[0].split('.').pop()?.toLowerCase() || '';
  return APPROVED_DESIGN_EXTENSIONS.includes(extension);
};

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

const CustomTab = styled(Tab)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  boxShadow: 'none', //theme.shadows[5],
  minHeight: 'fit-content',
  indicator: {
    display: 'none',
  },
  height: 38,
  fontSize: 12,
  borderRadius: 'none', //20
  border: '1.5px solid #00c2ff', //newlyadded
  background: '#161c24',
  margin: 0, //5
  color: theme.palette.text.primary,
  '&:hover': {
    background: '#161c24',
  },
  '&.Mui-selected': {
    background: theme.palette.primary.main,
    color: '#fff',
  },
  '&:first-child': {
    borderRadius: '7px 0 0 7px',
    borderLeft: `1.5px solid ${theme.palette.primary.main}`,
  },
  '&:nth-child(2)': {
    borderRadius: '0',
    borderLeft: '0',
  },
  '&:nth-child(3)': {
    borderRadius: '0',
    borderLeft: '0',
  },
  '&:last-child': {
    borderRadius: '0 7px 7px 0',
    borderLeft: '0',
  },

  [theme.breakpoints.up('lg')]: {
    marginRight: `0 !important`,
    minWidth: '20% !important',
  },
  [theme.breakpoints.down('lg')]: {
    marginRight: `0 !important`,
    minWidth: '20% !important',
  },
  [theme.breakpoints.down('sm')]: {
    marginRight: `0 !important`,
    minWidth: '30.33% !important',
  },
}))

const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { color: 'warning', label: 'Status: Draft' }
    case 2:
      return { color: 'info', label: 'Status: Open' }
    case 3:
      return { color: 'primary', label: 'Status: Evaluating' }
    case 4:
      return { color: 'success', label: 'Status: Accepted' }
    case 5:
      return { color: 'warning', label: 'Status: Closed' }
    case 6:
      return { color: 'error', label: 'Status: Rejected' }
    default:
      return { color: 'default', label: 'Status: Open' }
  }
}
const getFileType = (fileType) => {
  if (fileType.startsWith('image/')) {
    return 'image'
  } else if (fileType.startsWith('video/')) {
    return 'video'
  } else {
    return 'other'
  }
}
const getInstallationStatusLabel = (status) => {
  const labels = { 1: 'Installs', 2: 'Pickup', 3: 'Shipping' };
  return labels[status] || '';
};
const getMixedInstallationMessage = (mixedStatus) => {
  if (!Array.isArray(mixedStatus) || mixedStatus.length === 0) return 'Installation';
  const labels = [...new Set(mixedStatus)]
    .sort((a, b) => a - b)
    .map(getInstallationStatusLabel)
    .filter(Boolean);
  if (labels.length === 0) return 'Installation';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
};

export default function ViewProject({idOfProject,setProjectsId,popupOn,closeView,handleClickOpenRecipeCost,setRecipeCostId,setRecipeCostCurrentTab,setRenderCardsMain,setPostId,handleinnerTask,setTaskCurrentTab,setTaskdetails,onDataChange,fromCalender}) {
  const theme = useTheme()
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const { enqueueSnackbar } = useSnackbar()
  const ref = useRef(null)
  const componentRef = useRef()
  const navigate = useNavigate()
  const { id:ids } = useParams()
  const id = popupOn ? idOfProject : ids
  const fileInputRef = useRef()
  const [progress, setProgress] = useState(false)
  const user = JSON.parse(window.localStorage.getItem('user'))
  const explodedPermissions = user?.exploded_permissions
  const [isOpen, setIsOpen] = useState(false)
  const [secTab, setSecTab] = useState('Tasks')
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [add, setAdd] = useState(false)
  const [addMember, setAddMember] = useState(false)
  const [selected, setSelected] = useState([])
  const [data, setData] = useState(null)
  // console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaa', data)
  const [projectMembers, setProjectMembers] = useState(null)
  const [projectTask, setProjectTask] = useState(null)
  const [allTeamMembers, setAllTeamMembers] = useState(null)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [details, setDetails] = useState(null)
  // console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaa', details)
  const [requestServices, setRequestServices] = useState([])
  const [rfpServices, setRfpServices] = useState([])
  const [customerData, setCustomerData] = useState(null)
  const [designs, setDesigns] = useState([])
  const [invoice, setInvoice] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [renderCards, setRenderCards] = useState(false)
  const [fetchData, setFetchData] = useState(false)
  const [singleProjectData, setSingleProjectData] = useState(null)
  const [openAttachModal, setOpenAttachModal] = useState(false)
  const [attachments, setAttachments] = useState({})
  const [valueTab, setValueTab] = useState('one')
  const [refresh, setRefresh] = useState(false)
  const [signAgreements, setSignAgreements] = useState(null)
  const [portfolio, setPortfolio] = useState(null)
  const [customTemplate, setCustomTemplate] = useState(null)
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty, setDataEmpty] = useState(true)
  const [proposalData, setProposalData] = useState(null)
  const [component, setComponent] = useState(null)
  const [clientId,setClientId] = useState(null)
  const [openPopup, setOpenPopup] = useState(false)
  const [openPopupComplete, setOpenPopupComplete] = useState(false)
  const [openInstallationTypeDialog, setOpenInstallationTypeDialog] = useState(false)
  const [installationPopupData, setInstallationPopupData] = useState(null)
  const [openHoldPopup, setOpenHoldPopup] = useState(false)
  const [openRejectPopup, setOpenRejectPopup] = useState(false)
  const [openSubtaskValidationPopup, setOpenSubtaskValidationPopup] = useState(false)
  const [openServiceWorkflowConfirmation, setOpenServiceWorkflowConfirmation] = useState(false)
  const [openService, setOpenService] = useState(false)
  const [subTaskMembers, setSubTaskMembers] = useState([])
  const [clockInInputs, setClockInInputs] = useState([])
  const [pendingStatusUpdate, setPendingStatusUpdate] = useState(null)
  const [clockInLoading, setClockInLoading] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const [holdReason, setHoldReason] = useState('')
  const [isSubmittingHold, setIsSubmittingHold] = useState(false)
  const [holdReasonError, setHoldReasonError] = useState('')
  const [reason, setReason] = useState('')
  const [rejectFile, setRejectFile] = useState(null)
  const [isUploadingRejectFile, setIsUploadingRejectFile] = useState(false)
  const [isSubmittingReject, setIsSubmittingReject] = useState(false)
  const [status, setStatus] = useState(null)
  const [completeStatus, setCompleteStatus] = useState(1)
  const [loading, setLoading] = useState(false)
  const [reOpenJob, setReOpenJob] = useState(false)
  const [designersList, setDesignersList] = useState([])
  console.log('designersList', designersList)
  const [loadingJobCost, setLoadingJobCost] = useState(true)
  const [updatingTmDraft, setUpdatingTmDraft] = useState(false)
  const [openTmDraftConfirm, setOpenTmDraftConfirm] = useState(false)
  const [pendingTmDraftValue, setPendingTmDraftValue] = useState(0)
  const [installationCompleted,setAllInstallationCompleted] = useState(null)
  const [jobNoteMembers, setJobNoteMembers] = useState(null)
  const [isMember, setIsMember] = useState(false);
  const [updates, setUpdates] = useState(null)
  const socketRef = useRef(null)
  const [onlineUsers, setOnlineUsers] = useState([])
  const [collaborators, setCollaborators] = useState([])
  const [teamMembersOptions, setTeamMembersOptions] = useState([])
  const [teamMembersLoading, setTeamMembersLoading] = useState(false)
  const [options, setOptions] = useState([
    // { id: 6, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Inprogress' },
    { id: 3, value: 'Completed' },
    // { id: 4, value: 'Hold' },
    // { id: 5, value: 'Active' },
    // { id: 6, value: 'Rejected' },
    // { id: 7, value: 'Verified' },
    // { id: 6, value: 'Reopen' },
    // { id: 9, value: 'Rejected' },
  ])
  const location = useLocation()
  const [originParentRequestId, setOriginParentRequestId] = useState(null)
  let currentTab = location?.state?.currentTab
  const isFromInstallationCalendar = String(fromCalender) === "true" && localStorage.getItem("calendarSource") === "installation"
  const customerOrderStorageKey = id ? `viewProjectFromCustomerOrder_${id}` : null
  const staffCalendarStorageKey = id ? `viewProjectFromStaffCalendar_${id}` : null
  const communityJobStorageKey = id ? `viewProjectFromCommunityJob_${id}` : null
  const communityJobsBackStorageKey = id ? `viewProjectCommunityJobsBack_${id}` : null

  useEffect(() => {
    if (location?.state?.fromCustomerOrder && id) {
      sessionStorage.setItem(`viewProjectFromCustomerOrder_${id}`, '1')
    }
  }, [location?.state?.fromCustomerOrder, id])

  useEffect(() => {
    if (location?.state?.fromStaffCalendar && id) {
      sessionStorage.setItem(`viewProjectFromStaffCalendar_${id}`, '1')
    }
  }, [location?.state?.fromStaffCalendar, id])

  useEffect(() => {
    if (!id) return
    if (location?.state?.fromCommunityJob) {
      sessionStorage.setItem(`viewProjectFromCommunityJob_${id}`, '1')
      const listState = location.state?.communityJobsListState
      if (listState && communityJobsBackStorageKey) {
        try {
          sessionStorage.setItem(communityJobsBackStorageKey, JSON.stringify(listState))
        } catch (e) {
          /* ignore */
        }
      }
    }
  }, [location?.state?.fromCommunityJob, location?.state?.communityJobsListState, id, communityJobsBackStorageKey])

  const isFromCustomerOrder =
    Boolean(location?.state?.fromCustomerOrder) ||
    Boolean(customerOrderStorageKey && sessionStorage.getItem(customerOrderStorageKey) === '1')

  const isFromStaffCalendar =
    Boolean(location?.state?.fromStaffCalendar) ||
    Boolean(staffCalendarStorageKey && sessionStorage.getItem(staffCalendarStorageKey) === '1')

  const isFromCommunityJob =
    Boolean(location?.state?.fromCommunityJob) ||
    Boolean(communityJobStorageKey && sessionStorage.getItem(communityJobStorageKey) === '1')

  const isFromSplitJobs =  details?.is_split_order === 1
  const backToJobsRoute = isFromSplitJobs ? PATH_DASHBOARD.splitOrder.splitJobs : PATH_DASHBOARD.project.all
  const userType = user?.user_type;
  const {
    hasNew: designNotesHasNew,
    clearNew: clearDesignNotesNew,
  } = useJobNoteTabUnread({
    requestId: details?.id || null,
    designOrderId: details?.design_order_id || null,
    noteType: 'design',
    userId: user?.user_id,
    enabled: userType !== 3 && !!details?.id,
    isActiveTab: secTab === 'Design Notes',
    activeTab: secTab,
  })
  const {
    hasNew: jobNotesHasNew,
    clearNew: clearJobNotesNew,
  } = useJobNoteTabUnread({
    requestId: details?.id || null,
    designOrderId: details?.design_order_id || null,
    noteType: 'job',
    userId: user?.user_id,
    enabled: userType !== 3 && !!details?.id,
    isActiveTab: secTab === 'Job Notes',
    activeTab: secTab,
  })
  console.log('############location view project', currentTab)

  const handleMembersAdded = useCallback(
    async (newMemberIds = []) => {
      const validMemberIds = (newMemberIds || [])
        .map((memberId) => Number(memberId))
        .filter((memberId) => Number.isFinite(memberId) && memberId > 0);

      if (!validMemberIds.length) return;

      try {
        const response = await axios.post(
          `${REST_API_END_POINT}project/assign-new-members-to-subtasks-by-skill`,
          {
            projectId: Number(id),
            memberIds: validMemberIds,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response?.data?.status !== 1) {
          enqueueSnackbar(response?.data?.msg || 'Subtask auto-assign failed', { variant: 'warning' });
        }
      } catch (error) {
        console.error('Subtask auto-assign error:', error);
        enqueueSnackbar('Subtask auto-assign failed', { variant: 'warning' });
      }
    },
    [enqueueSnackbar, id]
  )
  
  // Fetch view type from backend
  const fetchViewType = async () => {
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      const res = await axios.post(`${REST_API_END_POINT}get-view-project-type`, { userId });
      if (res.data?.status === 1 && res.data?.data?.viewType !== undefined) {
        setValueTab(res.data.data.viewType);
      }
    } catch (error) {
      console.error('Error fetching view type:', error);
    }
  };
  
  // Load view type from backend on mount
  useEffect(() => {
    fetchViewType();
  }, []);
  
    const handleChange = async (event, newValue) => {
    setValueTab(newValue);
    
    // Save view type to backend
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      await axios.post(`${REST_API_END_POINT}update-view-project-type`, { userId, viewType: newValue });
    } catch (error) {
      console.error('Error updating view type:', error);
    }
  };
  const hasJobPermission = explodedPermissions?.some((permission) => ['Update Job Status'].includes(permission)) ? true : false
  const isSalesOrderVoided = Number(details?.status) === 10
  const [openRevertStatusDialog, setOpenRevertStatusDialog] = useState(false)
  const [selectedRevertOptionKey, setSelectedRevertOptionKey] = useState(null)
  const [isSubmittingStatusRevert, setIsSubmittingStatusRevert] = useState(false)

  const handleOpenRevertStatusDialog = () => {
    setSelectedRevertOptionKey(null);
    setOpenRevertStatusDialog(true);
  };

  const handleCloseRevertStatusDialog = () => {
    setOpenRevertStatusDialog(false);
    setSelectedRevertOptionKey(null);
  };

  const currentQS = Number(details?.quotation_status);
  const currentSt = Number(details?.status);
  const isQuotation = details?.quotation === 1 || details?.is_request_estimate === 1;
  const currentProjStatus = Number(details?.proj_status);
  const hasProject = !!currentProjStatus;

  const availableRevertOptions = useMemo(
    () =>
      buildRevertStatusOptions({
        isQuotation,
        currentQS,
        currentSt,
        currentProjStatus,
        hasProject,
      }),
    [isQuotation, currentQS, currentSt, hasProject, currentProjStatus],
  );

  const handleConfirmRevertStatus = async () => {
    const option = availableRevertOptions.find(
      (opt) => getRevertOptionKey(opt) === selectedRevertOptionKey
    );
    if (!option) {
      enqueueSnackbar('Please select a status to revert to', { variant: 'warning' });
      return;
    }
    await handleRevertStatus(option);
  };

  const handleRevertStatus = async (option) => {
    handleCloseRevertStatusDialog();
    setIsSubmittingStatusRevert(true);
    const payload = {
      requestId: details?.id,
      userId: user?.user_id || user?.id,
    };
    if (option.type === 'project') {
      payload.targetProjectStatus = option.value;
    } else if (option.type === 'quotation') {
      payload.targetQuotationStatus = option.value;
    } else {
      payload.targetStatus = option.value;
    }

    try {
      const res = await axios.post(`${REST_API_END_POINT}request/revert-status`, payload);
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRefresh((prev) => !prev);
        if(option.type === 'request' && popupOn && typeof closeView === 'function') {
          closeView()
        }
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Error reverting status', { variant: 'error' });
    } finally {
      setIsSubmittingStatusRevert(false);
    }
  };
  const handleback = () => {
    window.history.back()
  }

  const [data1, setData1] = useState({})
  const fetchDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}settings/get-companyProfile-details`,
      )
      if (res.data.status === 1) {
        setData1(...res.data.data)
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error)
    }
  }

  useEffect(() => {
    fetchDetails()
  }, [])

  const installationTypeSummary = useMemo(() => {
    const requestId = details?.id || data?.request_id
    if (!requestId || projectTask == null) return null
    const projectCategory = details?.project_category ?? data?.project_category
    const forceInstall = projectCategory === 11 || projectCategory === 12
    const toType = (id) => (forceInstall ? 1 : ([1, 2, 3].includes(Number(id)) ? Number(id) : null))
    const lines = []
    const tasks = projectTask || []
    const soTasks = tasks.filter((t) => !Number(t.is_manually_added) && (!t.service_id || t.product_id || Number(t.makeInstallCard) === 1))
    soTasks.forEach((t) => {
      const ty = toType(t.delivery_type_id || t.service_delivery_type_id)
      if (ty) lines.push({ name: t.name, type: ty })
    })
    if (!soTasks.length) {
      ;(invoice?.cust_product || []).filter((p) => !p.material && !p.rfp).forEach((p) => {
        const ty = toType(p.delivery_type_id)
        if (ty) lines.push({ name: p.product_notes || p.product_name, type: ty })
      })
      ;[...(requestServices || []), ...(rfpServices || [])].forEach((s) => {
        if (Number(s.makeInstallCard) !== 1) return
        const ty = toType(s.delivery_type_id)
        if (ty) lines.push({ name: s.name, type: ty })
      })
    } else {
      ;[...(requestServices || []), ...(rfpServices || [])].forEach((s) => {
        if (Number(s.makeAsTask) !== 0 || Number(s.makeInstallCard) !== 1) return
        const ty = toType(s.delivery_type_id)
        if (ty) lines.push({ name: s.name, type: ty })
      })
    }
    if (!lines.length) return null
    const types = [...new Set(lines.map((l) => l.type))]
    const viewRows = tasks.filter((t) => Number(t.is_manually_added) || !t.service_id || t.product_id || Number(t.makeInstallCard) === 1).map((t) => ({
      name: t.name,
      type: Number(t.is_manually_added) ? null : toType(t.delivery_type_id || t.service_delivery_type_id),
    }))
    const mixed = types.length > 1
    return {
      label: mixed ? 'Mixed installation' : getInstallationStatusLabel(types[0]),
      mixed,
      popupRows: mixed
        ? [...viewRows, ...lines.filter((l) => !soTasks.some((t) => t.name === l.name))]
        : lines,
    }
  }, [details, data, projectTask, invoice, requestServices, rfpServices])

  // Control available status options based on project category
  useEffect(() => {
    const fullStatusOptions = [
      // { id: 6, value: 'Inactive' },
      { id: 1, value: 'New' },
      { id: 2, value: 'Inprogress' },
      { id: 3, value: 'Completed' },
      // { id: 4, value: 'Hold' },
      // { id: 5, value: 'Active' },
      // { id: 9, value: 'Rejected' },
    ]
    const newCompletedOnly = [
      { id: 1, value: 'New' },
      { id: 3, value: 'Completed' },
      // { id: 9, value: 'Rejected' },
    ]

    // All tasks completed: only allow "Completed"
    if (data?.allTaskCompleted == 1) {
      setOptions(newCompletedOnly)
    }
    // Service Only (11): include Inprogress when the job has any task
    else if (details?.project_category == 11) {
      setOptions(projectTask?.length > 0 ? fullStatusOptions : newCompletedOnly)
    }
    // Time & Material jobs (project_category 12) with no tasks: hide "Inprogress"
    else if (details?.project_category == 12) { //&& projectTask?.length <= 0
      setOptions((prev) => prev?.filter((item) => item.id !== 2))
    } else {
      // Reset to original options when conditions are not met
      setOptions(fullStatusOptions)
    }
  }, [details, projectTask,data])
  // const handleJobsTabCount = async () => {
  //   try {
  //     const response = await axios.post(`${REST_API_END_POINT}jobs/reduce-tabs-count`, {
  //       userId:user.user_id,
  //       project_id:id,
  //     });
      
  //   } catch (error) {
  //     console.error("Error reducing sales order count:", error);
  //   }
  // };

  // useEffect(() => {
  //   handleJobsTabCount()
  // }, [])

  // Socket initialization for online users tracking
  useEffect(() => {
    if (!socketRef.current) {
      // OLD CODE (keep for future restore):
      // socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true });
      socketRef.current = createAppSocket();
    }
    if (user?.user_id && socketRef.current && id) {
      socketRef.current.emit("request-online-user", { userId: user.user_id, requestId: id });
      socketRef.current.emit("get-request-online-users", { requestId: id });
    }
    if (socketRef.current) {
      socketRef.current.on("update-request-online-users", (payload) => {
        if (!payload) return;
        const { requestId, users } = payload;
        if (String(requestId) !== String(id)) return;
        setOnlineUsers((users || []).map(String));
      });
    }
    return () => {
      if (socketRef.current && user?.user_id && id) {
        socketRef.current.emit("leave-request", { userId: user.user_id, requestId: id });
      }
      if (socketRef.current) socketRef.current.off("update-request-online-users");
    };
  }, [user?.user_id, id]);

  // Fetch team members for collaborators
  const fetchTeamMembersForCollaborators = async () => {
    setTeamMembersLoading(true);
    try {
      const isClient = user?.isClient || false;
      const userType = isClient ? 3 : user.user_type;
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: user.user_id,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
      setTeamMembersOptions([]);
    } finally {
      setTeamMembersLoading(false);
    }
  };

  // Fetch team members on mount
  useEffect(() => {
    if (user?.user_id) {
      fetchTeamMembersForCollaborators();
    }
  }, []);

  // Sync collaborators from details when team members options load
  useEffect(() => {
    const raw = details?.collaborators || null;
    if (!raw) return;
    const collaboratorIds = Array.isArray(raw)
      ? raw.map((c) => String(c?.id ?? c))
      : String(raw || '').split(',').map((s) => s.trim()).filter(Boolean);
    if (teamMembersOptions && teamMembersOptions.length > 0) {
      const selected = teamMembersOptions.filter((opt) => collaboratorIds.includes(String(opt.id)));
      setCollaborators(selected);
    }
  }, [teamMembersOptions, details?.collaborators]);

  const settings = {
    speed: 1000,
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    ...CarouselControlsPaging1({ color: 'primary.main' }),
  }

  console.log('holdcheck==currentTab==',currentTab)
  console.log('holdcheck==details==',details)
  console.log('holdcheck==data==',data)

  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(member => member.user_id === user.user_id);
      setIsMember(found);
    }
  }, [jobNoteMembers, user?.user_id]);

  console.log('isMemberisMember', isMember)

  const fetchRequestUpdates = async (request_id, search = '') => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-updates`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
          search,
        }
      )
      if (res.data.status === 1) {
        if (!search) {
          setUpdates(res.data.updates)
        }
        return res.data.updates || []
      }
      return []
    } catch (error) {
      console.error('Error fetching updates:', error)
      if (search) {
        return []
      }
    }
  }

  const handleJobLogSearch = useCallback(async (search) => {
    if (!details?.id) return []
    return fetchRequestUpdates(details.id, search)
  }, [details?.id, user.user_id, user.user_type])
  

  const TABS = [
    // ...(details?.job_category_name=='Service only' ? [] : [
    {
      value: 'Members',
      component: (
        <Members
          setFetchData={setFetchData}
          data={projectMembers}
          currentTab={currentTab}
          projectData={data}
          isMirrored={details?.for_parent_facility == 2}
        />
      ),
    },
    // ]),
    {
      value: 'Tasks',
      component: (
        <Tasks
        isTimeAndMaterial={details?.project_category === 12}
        isMirrored={details?.for_parent_facility == 2}
        setTaskdetails={setTaskdetails}
        setTaskCurrentTab={setTaskCurrentTab}
        setPostId={setPostId}
        popupOn={popupOn}
        setProjectsId={setProjectsId}
          details={data}
          requestStatus={details?.status}
          designs={designs}
          valueTab={valueTab}
          setFetchData={setFetchData}
          data={projectTask}
          projectId={id}
          refresh={refresh}
          setRefresh={setRefresh}
          currentTab={currentTab}
          handleinnerTask={()=>handleinnerTask()}
          onDataChange={onDataChange}
          projectMembers={projectMembers}
          subtaskcount={projectTask?.reduce((total, task) => total + (task.subtask_count || 0), 0) || 0}
        />
      ),
    },
    {
      value: 'Locations',
      component: (
        <Locations
          products={invoice?.cust_product}
          details={details}
          additionalSelectedServices={requestServices}
          designs={designs}
          isFullWidth
          rfpServices={rfpServices}
        />
      ),
    },
    {
      value: 'Attachments',
      component: <ProjectAttachment projectId={id} currentTab={currentTab} data={data} installationCompleted={installationCompleted} isMirrored={details?.for_parent_facility == 2} targetFacilityId={details?.origin_facility_id || null} originRequestId={originParentRequestId} hideAddButton={details?.for_parent_facility == 2 ? true : false}/>,
    },
    {
      value: `Order Details`,
      component: details ? (
        <ViewRequest
          products={invoice?.cust_product}
          teamMembers={projectMembers}
          // fetchRequestDetails={fetchRequestDetails}
          user={user}
          designs={designs}
          setDesigns={setDesigns}
          details={details}
          isRequest={true}
          requestId={id}
          signAgreements={signAgreements}
          customTemplate={customTemplate}
          questionnaireTemplate={questionnaireTemplate}
          allDataEmpty={allDataEmpty}
          portfolio={portfolio}
          project={true}
          clientDetails={customerData}
          designersList={designersList}
          isMirrored={details?.for_parent_facility == 2}
          onlineUsers={onlineUsers}
          allTeamMembers={teamMembersOptions}
        />
      ) : (
        ''
      ),
    },
    ...(isMember && userType !== 3 ? [
    {
      value: 'Job Notes',
      component: (
        <Card sx={{ height: '72vh', display: 'flex' }}>
          <JobNoteWindow
            products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={details?.id}
            designOrderId={details?.design_order_id || null}
            requestDetails={details}
            fromDesign={false}
            isDesignOrder={false}
            renderCards={renderCards}
            setRenderCards={setRenderCards}
            details={details}
            noteType="job"
          />
        </Card>
      ),
    },
    {
      value: 'Design Notes',
      component: (
        <Card sx={{ height: '72vh', display: 'flex' }}>
          <JobNoteWindow
            products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={details?.id}
            designOrderId={details?.design_order_id || null}
            requestDetails={details}
            fromDesign={true}
            isDesignOrder={false}
            renderCards={renderCards}
            setRenderCards={setRenderCards}
            details={details}
            noteType="design"
          />
        </Card>
      ),
    }
  ] : []),
    {
      value: 'Job Logs',
      component: <RequestTabUpdates updates={updates} details={details} searchable onSearchUpdates={handleJobLogSearch} />
    }
  ]
const handleClickforProject=(id,currentTab)=>{
  setRecipeCostCurrentTab(currentTab)
  setRecipeCostId(id)
  handleClickOpenRecipeCost()
}


console.log('detailsdetailsdetailsdetails',details)
  useEffect(() => {
    try {
      localStorage.setItem('params', '')
      if (!id) return
      const hasPermission = explodedPermissions?.some((permission) =>
        [
          'View Jobs',
          'Add Jobs',
          'Edit Jobs',
          'Activate/Deactivate Jobs',
          'Delete Jobs',
        ].includes(permission),
      )
        ? true
        : false
      setLoading(true)
      axios
        .post(
          `${REST_API_END_POINT}project/get-project-by-id`,
          {
            id: { value: id },
            userId: user.user_id,
            userType: user.user_type,
            hasPermission,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          setSingleProjectData(response.data)
          setValue(
            options?.find((opt) => response.data.result.status == opt.id),
          )
          setOriginParentRequestId(response?.data?.originParentRequestId || null)
          const originRequestId = response?.data?.originRequestId || response?.data?.result?.request_id ;
          fetchRequestDetails(originRequestId)
          fetchRequestServices(originRequestId)
          // fetchRequestDetails(response.data.result.request_id)
          setClientId(response.data?.result?.customer_id)
          setData(response.data.result)
          // console.log("task------ data",response.data.result);
          
          setProjectMembers(response.data.projectMembers)
          setProjectTask(response?.data?.projectTask)
          // console.log('projectTask-----------',response);
          
          setAllTeamMembers(response.data.teamMembers)
          setFetchData(false)
          setRefresh(false)
          // let option = options.filter(opt => opt.id=== response.data.result.status);
          // setOptions(option)
          console.log('##############3#333', response.data.result.status)
          console.log("projectTask", projectTask)
          // if (response.data.result.status === 3) {
          //   console.log("Status is 3");
          //   setOptions([
          //     { id: 3, value: 'Completed' },
          //     { id: 4, value: 'Hold' },
          //     { id: 5, value: 'Active' }
          //   ]);
          // }
          // else {
          //   setOptions([
          //     { id: 0, value: 'Inactive' },
          //     { id: 1, value: 'New' },
          //     { id: 2, value: 'Inprogress' },
          //     // { id: 3, value: 'Completed' },
          //     { id: 4, value: 'Hold' },
          //     { id: 5, value: 'Active' },
          //     // { id: 6, value: 'Rejected' },
          //     // { id: 7, value: 'Verified' },
          //     // { id: 6, value: 'Reopen' },
          //   ])
          //   console.log("Status is not 3, it is:", response.data.result.status);
          // }
          setTimeout(() => {
            setLoading(false)
          }, 1000)

          console.log('###############@@@@@@@@@@@@@@@', options)
        })
        .catch((error) => {
          console.error(error)
        })

      // handleFetchEditData(id)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }, [isEdit, fetchData, refresh, id])

  const fetchTimeLogData = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/fetch-clockedIn-staff-task-timelog`,
        { projectId: Number(id), taskId: null, userId: user.user_id, },
      )
      if (res.data.status === 1) {
        const staffTimeLogData = res.data.result[0];
        if (staffTimeLogData.end_time === null) {
          setIsLoggedIn(true)
        } else {
          setIsLoggedIn(false)
        }
      } else {
        setIsLoggedIn(false)
      }
    } catch (error) {
      console.log('Error fetching : ', error)
    }
  }

  useEffect(()=>{
    if(id){
      fetchTimeLogData()
    }
  },[id])

  //add, addMember,

  // const handleFetchEditData = useCallback((id) => {
  //   try {
  //     const  user  = JSON.parse(window.localStorage.getItem('user'))
  //     axios.post(`${REST_API_END_POINT}project/get-project-by-id`,{ id: { value: id}, userId:user.user_id, userType: user.user_type  },{
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     }).then((response) => {
  //       setSingleProjectData(response.data)

  //     }).catch((error) => {
  //       console.error(error);
  //     })
  //     }
  //     catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  // }, [isEdit]);

  const fetchRequestDetails = async (request_id) => {
    setLoading(true)
    try {
      console.log({ request_id })
      const res = await axios.post(`${REST_API_END_POINT}view-request-production-inner-page`, {
        request_id,
        userId: user.user_id,
        userType: user.user_type,
      })
      res.data
      // COMMENTED OUT - Moved to separate API call: getOrderDetailsData (will be called when Order Details tab is clicked)
      // setCustomerData(res.data.customerData)
      // setDesignersList(res.data.projectMembers)
      setDetails(res.data?.data[0])
      // COMMENTED OUT - Moved to separate API call: getJobNoteMembers (will be called when Job Notes tab is clicked)
      // setJobNoteMembers(res?.data?.jobNoteMembers)
      setAllInstallationCompleted(res.data?.data[0]?.allInstallationCompleted)
      // COMMENTED OUT - Moved to separate API call: getRequestUpdates (will be called when Job Logs tab is clicked)
      // setUpdates(res.data.updates)
      // if(res.data?.data[0]?.job_category_name=='Service only'){
      // setSecTab('Locations')
      // }else{
      setSecTab('Tasks')
      // }
      console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaa', res.data?.data[0])
      // COMMENTED OUT - Moved to separate API call: getRequestServices (will be called when Locations tab is clicked)
      // if (res.data?.data[0].project_category == 11) {
      //   setRfpServices(res.data.requestServices.filter((row) => row.rfp === 1))
      // }
      // setRequestServices(
      //   res.data.requestServices.filter((row) => row.rfp === 0),
      // )
      // COMMENTED OUT - Moved to separate API call: getRequestAttachments (will be called when Attachments tab is clicked)
      // setDesigns(res.data.attachments)
      fetchOrderProductDetails(res.data.data[0]?.id)
      // COMMENTED OUT - Moved to separate API call: getOrderDetailsData (will be called when Order Details tab is clicked)
      // setCustomTemplate(res.data.fieldTemplates)
      // setQuestionnaireTemplate(res.data.QuestionTemplates)
      // setSignAgreements(res.data.signAgrementData)
      // setDataEmpty(res.data.allDataEmpty)
      // setPortfolio(res.data.portfolio)
      setRefresh(false)
      setProposalData(res.data.requestProposals)
    } catch (error) {
      console.error('Error fetching request details:', error)
    } finally {
      setLoading(false)
    }
  }
const handleReopenJob = async () => {
  try {
    const res = await axios.post(`${REST_API_END_POINT}request/reopen-job`, {
      jobId: data?.id,
      requestId: data?.request_id,
      userId: user.user_id,
      userType: user.user_type,
    })
    if (res.data.status === 1) {
      enqueueSnackbar('Job reopened successfully', { variant: 'success' })
      setReOpenJob(false)
      // fetchRequestDetails()
      setRefresh(true)
      // onDataChange()
    } else {
      enqueueSnackbar('Job reopened failed', { variant: 'error' })
      setReOpenJob(false)
      setRefresh(true)
      // onDataChange()
    }
  }
  catch (error) {
    console.error('Error reopening job:', error)
  }
}

const handleToggleTmDraft = async () => {
  const requestId = details?.request_id || details?.id || data?.request_id || data?.id;
  if (!requestId || updatingTmDraft) return;
  try {
    setUpdatingTmDraft(true);
    const nextDraft = Number(pendingTmDraftValue) === 1 ? 1 : 0;
    const res = await axios.post(`${REST_API_END_POINT}project/update-tm-review-draft-status`, {
      requestId,
      isDraft: nextDraft,
      userId: user?.user_id
    });
    if (res?.data?.status === 1) {
      setDetails((prev) => ({ ...prev, tm_review_draft: nextDraft }));
      setData((prev) => ({ ...prev, tm_review_draft: nextDraft }));
      enqueueSnackbar(nextDraft === 1 ? 'Moved to Draft' : 'Released from Draft', { variant: 'success' });
    } else {
      enqueueSnackbar(res?.data?.message || 'Failed to update draft status', { variant: 'error' });
    }
  } catch (error) {
    enqueueSnackbar('Failed to update draft status', { variant: 'error' });
  } finally {
    setUpdatingTmDraft(false);
    setOpenTmDraftConfirm(false);
  }
}

const handleOpenTmDraftConfirm = () => {
  const requestId = details?.request_id || details?.id || data?.request_id || data?.id;
  if (!requestId || updatingTmDraft) return;
  const nextDraft = Number(details?.tm_review_draft || 0) === 1 ? 0 : 1;
  setPendingTmDraftValue(nextDraft);
  setOpenTmDraftConfirm(true);
}
  const fetchRequestAttachments = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-attachments`,
        {
          request_id,
          isMirrored:details?.for_parent_facility == 2,
          targetFacilityId:details?.origin_facility_id || null,
        }
      )
      if (res.data.status === 1) {
        setDesigns(res.data.attachments)
      }
    } catch (error) {
      console.error('Error fetching attachments:', error)
    }
  }

  const fetchRequestServices = async (request_id) => {
    if (!request_id) return
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-services`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
        }
      )
      if (res.data.status === 1) {
        const allServices = res.data.requestServices || []
        setRfpServices(allServices.filter((row) => row.rfp === 1))
        setRequestServices(allServices.filter((row) => row.rfp === 0))
      }
    } catch (error) {
      console.error('Error fetching request services:', error)
    }
  }

  useEffect(() => {
    if (details?.id) fetchRequestServices(details.id)
  }, [details?.id])

  const fetchJobNoteMembers = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-job-note-members`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
        }
      )
      if (res.data.status === 1) {
        setJobNoteMembers(res.data.jobNoteMembers)
      }
    } catch (error) {
      console.error('Error fetching job note members:', error)
    }
  }

  const fetchOrderDetailsData = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-order-details-data`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
        }
      )
      if (res.data.status === 1) {
        if (res.data.projectMembers) {
          // setProjectMembers(res.data.projectMembers)
          setDesignersList(res.data.projectMembers)
        }
        setPortfolio(res.data.portfolio)
        setCustomTemplate(res.data.fieldTemplates)
        setQuestionnaireTemplate(res.data.QuestionTemplates)
        setSignAgreements(res.data.signAgrementData)
        setDataEmpty(res.data.allDataEmpty)
        setCustomerData(res.data.customerData)
      }
    } catch (error) {
      console.error('Error fetching order details data:', error)
    }
  }

  const fetchOrderProductDetails = async (orderId) => {
    setLoadingJobCost(true)
    try {
      // let orderId = details?.id;
      const res = await axios.post(
        `${REST_API_END_POINT}get-customer-order-product/${orderId}`,
      )
      await setInvoice(res.data.data)

      localStorage.setItem('params', res?.data?.data?.request_id)
    } catch (error) {
      console.error('Error fetching request details:', error)
      throw error
    } finally {
      setLoadingJobCost(false)
    }
  }
  // const handleUpdateStatus = async (optio) => {
  //   try {
  //     setOpenPopup(false)
  //     setOpenPopupComplete(false)
  //     setValue(optio)
  //     let status = optio?.id
  //     const user = JSON.parse(window.localStorage.getItem('user'))
  //     console.log('ghghfghfghfghfg',completeStatus);
      
  //     // const response = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,{selectedIds,userId:user.user_id})
  //     // const res = await axios.post(`${REST_API_END_POINT}project/update-project-status`,
  //     const res = await axios
  //       .post(
  //         `${REST_API_END_POINT}${
  //           status == 3
  //             ? `installation/convert-job-to-installation`
  //             : `project/update-project-status`
  //         }`,
  //         {
  //           status,
  //           selectedIds: Number(id),
  //           userId: user.user_id,
  //           userType:user.user_Type,
  //           projectId: Number(id),
  //           completeStatus:Number(completeStatus),
  //           clientId : clientId
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //         },
  //       )
  //       .then((response) => {
  //         if (response.data.status === 1) {
  //           setRefresh(true)
  //           onDataChange()
  //           enqueueSnackbar(
  //            `${status === 3
  //               // ? details?.noServiceNoTask == 1 ? 'Moved To "No Service No Task"' : (Number(completeStatus) === 1
  //               ? details?.noServiceNoTask == 1 ? 'Job completed without installation' : (Number(completeStatus) === 1
  //                   ? 'Moved To Installs'
  //                   : Number(completeStatus) === 2
  //                   ? 'Moved To Pickup'
  //                   : 'Moved To Shipping')
  //               : 'Success'}`,
  //             { variant: 'success' },
  //           )
  //         } else if (response.data.status === 0) {
  //           enqueueSnackbar(
  //             `${status == 3 ?(Number(completeStatus) === 1
  //               ? 'Not Moved To Installs'
  //               : Number(completeStatus) === 2
  //               ? 'Not Moved To Pickup'
  //               : 'Not Moved To Shipping') : 'Failed'}`,
  //             { variant: 'error' },
  //           )
  //         }
  //       })
  //   } catch (error) {
  //     console.error('Error status update:', error)
  //     throw error
  //   }
  // } uncomment this if it causes any error 

  const getAllStageMembers = () => {
    const members = []
    projectTask?.forEach((task) => {
      const taskId = task.id || task.ID
      const taskName = task.task_name || task.name || ''
      task.subTasks?.forEach((subtask) => {
        subtask.teamMembers?.forEach((member) => {
          members.push({
            ...member,
            task_id: taskId,
            // task_name added so same subtask under different tasks is clear in the list
            task_name: taskName,
            subtask_id: subtask.id || subtask.ID,
            subtask_name: subtask.name,
            rowKey: `${subtask.id || subtask.ID}-${member.staff_id}`,
          })
        })
      })
    })
    return members
  }

  const updateClockInInput = (rowKey, data) => {
    setClockInInputs((prev) => {
      const exists = prev.find((item) => item.rowKey === rowKey)
      if (exists) {
        return prev.map((item) =>
          item.rowKey === rowKey ? { ...item, ...data } : item
        )
      }
      return [...prev, { rowKey, ...data }]
    })
  }

  const getClockInPayload = () => {
    const now = moment().unix()
    return clockInInputs
      .filter((entry) => entry.hour > 0)
      .map((entry) => {
        const staffMember = subTaskMembers.find((member) => member.rowKey === entry.rowKey)
        const staffName = staffMember?.name || staffMember?.staff_name || 'N/A'
        const taskData = projectTask?.find(
          (task) => (task.id || task.ID) === (entry.task_id || staffMember?.task_id)
        )
        const taskName = taskData?.task_name || taskData?.name || 'N/A'
        return {
          ...entry,
          staff_id: entry.staff_id || staffMember?.staff_id,
          subtask_id: entry.subtask_id || staffMember?.subtask_id,
          subtask_name: entry.subtask_name || staffMember?.subtask_name,
          task_id: entry.task_id || staffMember?.task_id,
          start_time: now - Math.round(entry.hour * 3600),
          end_time: now,
          staff_name: staffName,
          task_name: taskName,
          userId: staffMember?.userId || staffMember?.user_id || entry.userId,
          user_id: staffMember?.userId || staffMember?.user_id || entry.user_id,
          hourly_rate: entry.hourly_rate || staffMember?.hourly_rate,
        }
      })
  }

  const visibleClockInMembers =
    userType === 1 || userType === 8 || userType === 2 || userType === 9
      ? subTaskMembers
      : subTaskMembers.filter(
          (item) => item.userId === user?.user_id || item.user_id === user?.user_id
        )

  const isClockInDisabled = visibleClockInMembers.every((member) => {
    const entry = clockInInputs.find((e) => e.rowKey === member.rowKey)
    return !(entry?.hour > 0)
  })

  const handleCloseClockIn = () => {
    setOpenService(false)
    setClockInInputs([])
    setSubTaskMembers([])
    setPendingStatusUpdate(null)
  }

  const handleJobCompleteClockIn = async () => {
    setClockInLoading(true)
    const now = moment().unix()
    const memberClockins = getClockInPayload()

    if (memberClockins.length === 0) {
      enqueueSnackbar('Please enter time for at least one member', { variant: 'error' })
      setClockInLoading(false)
      return
    }

    const groups = memberClockins.reduce((acc, entry) => {
      const key = `${entry.task_id}-${entry.subtask_id}`
      if (!acc[key]) {
        acc[key] = { taskId: entry.task_id, subtaskId: entry.subtask_id, entries: [] }
      }
      acc[key].entries.push(entry)
      return acc
    }, {})

    try {
      for (const { taskId, subtaskId, entries } of Object.values(groups)) {
        const res = await axios.post(
          `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
          {
            projectId: id,
            taskId,
            userId: user?.user_id,
            isDriver: false,
            memberClockins: entries,
            checkedItems: [String(subtaskId)],
            now,
            request_id: details?.id,
          }
        )
        if (res.data.status !== 1) {
          enqueueSnackbar('Clock-in failed', { variant: 'error' })
          setClockInLoading(false)
          return
        }
      }

      const statusToApply = pendingStatusUpdate
      handleCloseClockIn()
      if (statusToApply) {
        await handleUpdateStatus(statusToApply.optio, statusToApply.stockData, true)
      }
    } catch (error) {
      console.error('Clock-in error:', error)
      enqueueSnackbar('Clock-in failed', { variant: 'error' })
    } finally {
      setClockInLoading(false)
    }
  }

  const handleUpdateStatus = async (optio, stockData, skipClockIn = false) => {
    try {
      setOpenPopup(false);
      setOpenPopupComplete(false);

      const statusId = optio?.id ?? optio
      const completingJob = statusId === 3

      // Same as estimate jobs: confirm complete → time popup with subtask users, then complete
      if (completingJob && !skipClockIn) {
        const allMembers = getAllStageMembers()
        if (allMembers.length > 0) {
          setPendingStatusUpdate({ optio, stockData })
          setSubTaskMembers(allMembers)
          setOpenService(true)
          return
        }
      }

      setValue(optio);

      const status = optio?.id;
      const user = JSON.parse(window.localStorage.getItem('user'));
      // Use override only for the API payload (keeps existing snackbar logic unchanged)
      const apiCompleteStatus =
        optio?.completeStatus != null ? Number(optio.completeStatus) : Number(completeStatus) || 1;

      const isBuildOrderJob = status === 3 && (details?.project_category === 15 && details?.is_split_order !== 1);
      const isNoChargeJob = status === 3 && details?.project_category === 13 && Number(apiCompleteStatus) === 4;
      
      // Check if all services have both task toggle and install toggle off (goes to invoicing)
      const allServices = [...(requestServices || []), ...(rfpServices || [])];
      const allServicesBothTogglesOff = (details?.project_category === 11 && allServices.length > 0) && 
        allServices.every(service => service.makeAsTask === 0 && service.makeInstallCard === 0);
      
      // Check if project category 13 with all install cards off (goes to invoicing)
      const isProject13AllInstallCardsOff = details?.project_category === 11 && 
        ((details?.noServiceNoTask === 1) ||
         (allServices.length === 0 || allServices.every(service => service.makeInstallCard === 0)));

      const endpoint = isBuildOrderJob
        ? 'installation/complete-job-build-order'
        : isNoChargeJob
          ? 'installation/complete-job-no-charge'
        : status === 3
          ? 'installation/convert-job-to-installation'
          : 'project/update-project-status';

      const response = await axios.post(
        `${REST_API_END_POINT}${endpoint}`,
        {
          status,
          selectedIds: Number(id),
          userId: user.user_id,
          userType: user.user_Type,
          projectId: Number(id),
          completeStatus: Number(apiCompleteStatus),
          clientId: clientId,
          projectCategory: details?.project_category,
          request_id : details?.id,
          stockData: stockData || null,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const mixedInstallation = response.data?.mixed_installation
      const mixed_status = response.data?.mixed_status
      const mixedInstallMessage = getMixedInstallationMessage(mixed_status)

      if (response.data.status === 1) {
        setRefresh(true);
        onDataChange?.();
        enqueueSnackbar(
          `${status === 3
            ? (details?.project_category === 15 && details?.is_split_order !== 1)
              ? 'Moved To Invoicing'
              : isNoChargeJob
                ? 'Moved To Invoicing'
              // :details?.project_category === 12 ? "Job has been sent for review" 
              : (details?.noServiceNoTask == 1 && details?.project_category !== 12)
                ? 'Job completed without installation'
              : ((allServicesBothTogglesOff && details?.project_category !== 12) && Number(apiCompleteStatus) === 1)
                ? 'Moved To Invoicing'
              : (isProject13AllInstallCardsOff && details?.project_category !== 12 && Number(apiCompleteStatus) === 1)
                ? 'Moved To Invoicing'
              : mixedInstallation
                ? `Moved To ${mixedInstallMessage}`
                : Number(apiCompleteStatus) === 1
                  ? 'Moved To Installs'
                  : Number(apiCompleteStatus) === 2
                    ? 'Moved To Pickup'
                    : 'Moved To Shipping'
            : 'Success'
          }`,
          { variant: 'success' }
        );
      } else if (response.data.status === 0) {
        enqueueSnackbar(
          `${status === 3
            ? (details?.project_category === 15 && details?.is_split_order !== 1)
              ? 'Not Moved To Completed'
              : isNoChargeJob
                ? 'Not Moved To Completed'
              : ((allServicesBothTogglesOff && details?.project_category != 12 )&& Number(apiCompleteStatus) === 1)
                ? 'Not Moved To Invoicing'
              : ((isProject13AllInstallCardsOff && details?.project_category != 12) && Number(apiCompleteStatus) === 1)
                ? 'Not Moved To Invoicing'
              : mixedInstallation
                ? `Not Moved To ${mixedInstallMessage}`
                : Number(apiCompleteStatus) === 1
                  ? 'Not Moved To Installs'
                  : Number(apiCompleteStatus) === 2
                    ? 'Not Moved To Pickup'
                    : 'Not Moved To Shipping'
            : 'Failed'
          }`,
          { variant: 'error' }
        );
      }
    } catch (error) {
      console.error('Error status update:', error);
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    }
  };

  const handleUpdateHoldStatus = async (reason) => {
    if (Number(data?.status) === 9 || Number(data?.is_rejected) === 1) return;
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-job-hold-status`,
        {
          projectId: Number(id),
          request_id: details?.id,
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        setRefresh(!refresh);
        onDataChange?.();
        enqueueSnackbar(res.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  }

  const handleRejectFileDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return

      const file = acceptedFiles[0] // single file only
      setIsUploadingRejectFile(true)

      try {
        const timestamp = Date.now()
        const sanitizedName = file.name.replace(/\s+/g, '_')
        const fileName = `${timestamp}_${sanitizedName}`
        const filePath = `sales-order/rejected/${fileName}`

        const { error: uploadError } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file)

        if (uploadError) throw uploadError

        const { data: publicUrlData, error: urlError } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath)

        if (urlError || !publicUrlData?.publicUrl) {
          throw new Error('Failed to generate public URL')
        }

        setRejectFile({
          url: publicUrlData.publicUrl,
          file_type: file.type,
          extension: file.name.split('.').pop(),
          size: file.size,
        })
      } catch (err) {
        console.error('Upload error:', err.message)
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' })
      } finally {
        setIsUploadingRejectFile(false)
      }
    },
    [enqueueSnackbar],
  )

  const handleRejectJob = async () => {
    try {
      if (Number(data?.hold) === 1) return;
      if (!reason || reason === '') {
        enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
        return
      }

      const requestId = details?.id
      const requestPartnerId = details?.rt_partner_id
      const mirroredOrder = details?.for_parent_facility == 1

      if (!requestId || !requestPartnerId) {
        enqueueSnackbar('Unable to reject: missing Sales Order details', { variant: 'error' })
        return
      }

      setIsSubmittingReject(true)

      // Rejects sales order (status 6) and marks job rejected (status 9) without deleting the project
      const res = await axios.post(
        `${REST_API_END_POINT}request/reject-sales-order-from-job`,
        {
          requestId,
          requestPartnerId,
          userId: user?.user_id,
          reason,
          billing_type: details?.billing_type,
          mirroredOrder,
          rejectFile,
        },
        { headers: { 'Content-Type': 'application/json' } },
      )

      if (res?.data?.status === 2) {
        enqueueSnackbar('Job rejected successfully', { variant: 'success' })
        setOpenRejectPopup(false)
        setReason('')
        setRejectFile(null)
        onDataChange && onDataChange()
setRefresh(true)
        // if (popupOn && closeView) {
        //   closeView()
        // } else {
        //   navigate(PATH_DASHBOARD.project.all)
        // }
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to reject', { variant: 'error' })
      }
    } catch (error) {
      console.error('Error rejecting job:', error)
      enqueueSnackbar('Something went wrong while rejecting', { variant: 'error' })
    } finally {
      setIsSubmittingReject(false)
    }
  }
  const handlePopup = async (opto) => {
    if(opto.value === 'Completed'){
      // if(details?.project_category == 15 && details?.for_parent_facility == 1 && details?.is_split_order == 1){
      const filteredData = projectTask?.filter(item => item.is_manually_added == 0);
      let nextStatus = { ...opto };
      if(filteredData?.[0]?.delivery_type_id || filteredData?.[0]?.service_delivery_type_id || data?.service_delivery_id || data?.product_delivery_id){
        const autoCompleteStatus = Number(filteredData?.[0]?.delivery_type_id || filteredData?.[0]?.service_delivery_type_id || data?.service_delivery_id || data?.product_delivery_id || 1)
        console.log('autoCompleteStatussss', autoCompleteStatus)
        setCompleteStatus(autoCompleteStatus)
      //   setStatus(opto)
      //   handleUpdateStatus({ ...opto, completeStatus: autoCompleteStatus })
      //   return
      // }
      // if(details?.project_category == 14){ // old code deleted
        nextStatus = { ...opto, completeStatus: autoCompleteStatus }
      } else if(details?.project_category == 14){
        setCompleteStatus(1);
      //   setStatus(opto);
      //   handleUpdateStatus(opto);
      // }else{ // old code deleted
      } else {
        // Fetch requestServices if needed to check service task and install card status
        if(details?.id && 
           ((!requestServices || requestServices.length === 0) && (!rfpServices || rfpServices.length === 0))){
          await fetchRequestServices(details.id);
        }
        // setOpenPopupComplete(true)
        const autoCompleteStatus = Number(filteredData?.[0]?.delivery_type_id || filteredData?.[0]?.service_delivery_type_id || data?.service_delivery_id || data?.product_delivery_id || 1)
        setCompleteStatus(autoCompleteStatus)
        // setStatus(opto)
        // handleUpdateStatus({ ...opto, completeStatus: autoCompleteStatus })
        // return // old code deleted
        nextStatus = { ...opto, completeStatus: autoCompleteStatus }
      }
      // Show confirmation first (then time popup on Yes) — same as estimate jobs
      // setStatus(opto)
      // handleUpdateStatus(...)
      setStatus(nextStatus)
      setOpenPopup(true)
      return
    }else{
      setOpenPopup(true)        
      // setValue(optio)
    }
    setStatus(opto) 
  }
  useEffect(()=>{
    if (details?.id && secTab == 'Tasks') {
      fetchRequestAttachments(details.id)
      fetchOrderDetailsData(details.id)
      fetchJobNoteMembers(details.id)
    }
  },[details?.id])
  const handleTab = (event, newValue) => {
    setSecTab(newValue)
    if (newValue === 'Design Notes') {
      clearDesignNotesNew()
    }
    if (newValue === 'Job Notes') {
      clearJobNotesNew()
    }
    // Fetch attachments and order details data only when Order Details tab is clicked
    if (newValue === 'Order Details' && details?.id) {
      fetchRequestAttachments(details.id)
      fetchOrderDetailsData(details.id)
    }
    // Fetch updates only when Job Logs tab is clicked
    if (newValue === 'Job Logs' && details?.id) {
      fetchRequestUpdates(details.id)
    }
    // Fetch request services only when Locations tab is clicked
    if (newValue === 'Locations' && details?.id) {
      fetchRequestServices(details.id)
    }
    // Fetch job note members only when Job Notes tab is clicked
    // if (newValue === 'Job Notes' && details?.id) {
    //   fetchJobNoteMembers(details.id)
    // }
  }
  //////////////////////
  const handleFileChange = async (event) => {
    const files = event.target.files

    if (files.length === 0) {
      return
    }

    const uploadPromises = Array.from(files).map(async (file) => {
      const filename = new Date().getTime() + file.name
      const storageRef = imageref(storage, filename)
      const uploadTask = uploadBytesResumable(storageRef, file)

      return new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const prog = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
            )
            setProgress(true)
          },
          (error) => {
            console.error(error.message)
            setProgress(false)
            reject(error)
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref)
              .then((downloadURL) => {
                resolve({ downloadURL, fileType: getFileType(file.type) })
              })
              .catch((error) => {
                console.error(error.message)
                reject(error)
              })
          },
        )
      })
    })

    try {
      const validFileUploads = await Promise.all(uploadPromises)
      const newAttachments = validFileUploads.reduce(
        (acc, { downloadURL, fileType }) => {
          acc[fileType] = acc[fileType] || []
          acc[fileType].push(downloadURL)
          return acc
        },
        {},
      )

      setAttachments((prevAttachments) => ({
        ...prevAttachments,
        image: [
          ...(prevAttachments.image || []),
          ...(newAttachments.image || []),
        ],
        video: [
          ...(prevAttachments.video || []),
          ...(newAttachments.video || []),
        ],
        other: [
          ...(prevAttachments.other || []),
          ...(newAttachments.other || []),
        ],
      }))
      setProgress(false)
    } catch (error) {
      console.error('Error uploading files:', error)
    }
  }

  const RemoveAttachFromSubmit = (type, value) => {
    const deleteRef = imageref(storage, value)

    deleteObject(deleteRef)
      .then(() => {
        // File deleted successfully
        setAttachments((prevState) => ({
          ...prevState,
          [type]: (prevState[type] || []).filter((item) => item !== value),
        }))
      })
      .catch((error) => {
        console.error('Error deleting file:', error)
      })
  }

  const handleSubmitAttachments = async () => {
    try {
      if (Object.keys(attachments).length === 0) {
        enqueueSnackbar('Please provide attachments', { variant: 'warning' })
        return
      }
      let user = JSON.parse(window.localStorage.getItem('user'))
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/add-project-attachment`,
        {
          attachments,
          taskId,
          projectId,
          userId: user.user_id,
          request_id: details?.id,
        },
      )
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
      }
      setAttachments({})
      setOpenAttachModal(false)
    } catch (error) {
      console.log(error)
    }
  }
  const valuetext = (value) => {
    return `${value}%`
  }
  const updateStatus = (event, value) => {
    let values = {}
    let user = JSON.parse(window.localStorage.getItem('user'))
    values.completion = event.target.value
    values.projectId = Number(id)
    values.added_by = user.user_id
    if (event.target.value && values.projectId) {
      axios.post(
        `${REST_API_END_POINT}project/update-project-progress`,
        { ...values },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          // headers: { 'Content-Type': 'multipart/form-data' }
        },
      )
    }
  }
  // if(loading){

  //   <Stack alignItems='center' justifyContent='center'>
  //     <LoadingScreen  />
  //   </Stack>
  // }
  console.log('##################Loading', loading)
  return (
    <>
      {loading ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: '100vh' }}
        >
          <LoadingScreen />
        </Stack>
      ) : (
        <Container>
          {!isEdit ? (
            <Grid container spacing={3}>
              <Grid key={1} item xs={12} md={8}>
                <Stack direction="row" spacing={2} alignItems="center" mt={2}>
                  {popupOn?
                  <>
                    <Button
                      variant="outlined"
                      type="button"
                      size="small"
                      onClick={()=>{
                        if(fromCalender==="true"){
                          localStorage.removeItem("projectId");
                          localStorage.removeItem("projectName");
                          localStorage.removeItem("view");
                          localStorage.removeItem("jobsFromCalender");
                          localStorage.removeItem("openProductionPopup");
                          localStorage.removeItem("calendarSource");
                          if (customerOrderStorageKey) sessionStorage.removeItem(customerOrderStorageKey)
                          if (staffCalendarStorageKey) sessionStorage.removeItem(staffCalendarStorageKey)
                          if (isFromInstallationCalendar) {
                            navigate(PATH_DASHBOARD.calendar)
                          } else {
                            navigate(backToJobsRoute)
                          }
                        }else if (isFromCustomerOrder) {
                          localStorage.removeItem("projectId");
                          localStorage.removeItem("projectName");
                          localStorage.removeItem("view");
                          localStorage.removeItem("jobsFromCalender");
                          localStorage.removeItem("openProductionPopup");
                          localStorage.removeItem("calendarSource");
                          if (customerOrderStorageKey) sessionStorage.removeItem(customerOrderStorageKey)
                          if (staffCalendarStorageKey) sessionStorage.removeItem(staffCalendarStorageKey)
                          navigate(PATH_DASHBOARD.customerOrders.root)
                          closeView()
                        }else if (isFromCommunityJob) {
                          let backState = location.state?.communityJobsListState
                          if (!backState && communityJobsBackStorageKey) {
                            try {
                              const raw = sessionStorage.getItem(communityJobsBackStorageKey)
                              if (raw) backState = JSON.parse(raw)
                            } catch (e) {
                              backState = null
                            }
                          }
                          if (communityJobStorageKey) sessionStorage.removeItem(communityJobStorageKey)
                          if (communityJobsBackStorageKey) sessionStorage.removeItem(communityJobsBackStorageKey)
                          localStorage.removeItem("openProductionPopup");
                          navigate(PATH_DASHBOARD.community.rfqProjects, {
                            replace: true,
                            ...(backState ? { state: backState } : {}),
                          })
                          closeView()
                        }else{
                          localStorage.removeItem("openProductionPopup");
                          closeView()
                        }
                        }}
                      // component={RouterLink}
                      // to={PATH_DASHBOARD.project.all}
                      sx={{ alignItems: 'flex-end' }}
                      startIcon={
                        <Stack>
                          <KeyboardBackspaceOutlined />
                        </Stack>
                      }
                    >
                      {isFromInstallationCalendar || isFromCustomerOrder || isFromCommunityJob ? 'Go Back' : 'Back to All Jobs'}
                    </Button>
                    <Button
                    variant="outlined"
                    type="submit"
                    size="small"
                    onClick={()=>{
                      if(fromCalender==="true"){
                        closeView()                      
                      }else{
                        localStorage.removeItem("projectId");
                          localStorage.removeItem("projectName");
                          localStorage.removeItem("view");
                          localStorage.removeItem("jobsFromCalender");
                          localStorage.removeItem("openProductionPopup");
                        navigate(ROOTS_PCB)
                      }
                      }}
                    // component={RouterLink}
                    // to={ROOTS_PCB}
                    sx={{ alignItems: 'flex-end', mt: -2 }}
                    startIcon={
                      <Stack>
                        <KeyboardBackspaceOutlined />
                      </Stack>
                    }
                  >
                    Back to Home
                  </Button>
                  </>
                  :
                  <>
                    <Button
                    variant="outlined"
                    type="button"
                    size="small"
                    onClick={() => {
                      if (isFromCustomerOrder) {
                        if (customerOrderStorageKey) sessionStorage.removeItem(customerOrderStorageKey)
                        if (staffCalendarStorageKey) sessionStorage.removeItem(staffCalendarStorageKey)
                        navigate(PATH_DASHBOARD.customerOrders.root)
                      } else if (isFromStaffCalendar) {
                        if (staffCalendarStorageKey) sessionStorage.removeItem(staffCalendarStorageKey)
                        if (customerOrderStorageKey) sessionStorage.removeItem(customerOrderStorageKey)
                        navigate(PATH_DASHBOARD.staffSchedular.root)
                      } else if (isFromCommunityJob) {
                        let backState = location.state?.communityJobsListState
                        if (!backState && communityJobsBackStorageKey) {
                          try {
                            const raw = sessionStorage.getItem(communityJobsBackStorageKey)
                            if (raw) backState = JSON.parse(raw)
                          } catch (e) {
                            backState = null
                          }
                        }
                        if (communityJobStorageKey) sessionStorage.removeItem(communityJobStorageKey)
                        if (communityJobsBackStorageKey) sessionStorage.removeItem(communityJobsBackStorageKey)
                        if (customerOrderStorageKey) sessionStorage.removeItem(customerOrderStorageKey)
                        if (staffCalendarStorageKey) sessionStorage.removeItem(staffCalendarStorageKey)
                        localStorage.removeItem("projectId");
                        localStorage.removeItem("projectName");
                        localStorage.removeItem("view");
                        localStorage.removeItem("jobsFromCalender");
                        localStorage.removeItem("openProductionPopup");
                        navigate(PATH_DASHBOARD.community.rfqProjects, {
                          replace: true,
                          ...(backState ? { state: backState } : {}),
                        })
                      } else {
                        localStorage.removeItem("projectId");
                      localStorage.removeItem("projectName");
                      localStorage.removeItem("view");
                      localStorage.removeItem("jobsFromCalender");
                      localStorage.removeItem("openProductionPopup");
                      if (customerOrderStorageKey) sessionStorage.removeItem(customerOrderStorageKey)
                      if (staffCalendarStorageKey) sessionStorage.removeItem(staffCalendarStorageKey)
                      navigate(backToJobsRoute);
                      }
                    }}
                    // onClick={closeView}
                    // component={RouterLink}
                    // to={ isFromCommunityJob ? window.history.back() :PATH_DASHBOARD.project.all}
                    sx={{ alignItems: 'flex-end' }}
                    startIcon={
                      <Stack>
                        <KeyboardBackspaceOutlined />
                      </Stack>
                    }
                  >
                    {isFromStaffCalendar || isFromCustomerOrder || isFromCommunityJob ? 'Go Back' : 'Back to All Jobs'}
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    size="small"
                    component={RouterLink}
                    to={ROOTS_PCB}
                    sx={{ alignItems: 'flex-end', mt: -2 }}
                    startIcon={
                      <Stack>
                        <KeyboardBackspaceOutlined />
                      </Stack>
                    }
                  >
                    Back to Home
                  </Button>
                  </>
                }
                  
                </Stack>
                <HeaderBreadcrumbs
                  sx={{ mt: 2 }}
                  // heading={"Job Details"}
                  heading={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                      Job Details {details?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
                      {isSalesOrderVoided && (
                        <Label variant="filled" color="error">
                          Void
                        </Label>
                      )}
                    </Box>
                  }
                  action={
                    <Stack direction={'row'} spacing={2}>
                      {secTab === 'Tasks' && (
                        <Tabs
                          value={valueTab}
                          onChange={handleChange}
                          textColor="secondary"
                          indicatorColor="none"
                          aria-label="secondary tabs example"
                        >
                          <CustomTab value="one" icon={<ViewModule />} />
                          <CustomTab value="two" icon={<ViewList />} />
                          <CustomTab value="three" icon={<List />} />
                        </Tabs>
                      )}
                    </Stack>
                  }
                />
                {/* <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="none"
                aria-label="secondary tabs example"
              >
                <CustomTab value="one" icon={<List />} />
                <CustomTab value="two" icon={<ViewList  />}/>
                <CustomTab value="three" icon={<ViewModule />} />
              </Tabs> */}

                <Stack spacing={1}>
                  {details && (
                    <Box
                      sx={{
                        border: `2.5px solid ${theme.palette.primary.main}`,
                        borderRadius: 1,
                        p: 2.5,
                        mb: 2,
                      }}
                    >
                      <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        {details?.installation_acceptance && details?.est_doc_number && details?.doc_number !== details?.est_doc_number ? (
                          <>
                            <Tooltip title={`Job Number: ${details?.est_doc_number ? `#${details?.est_doc_number}` : ''}`}>
                              <Typography noWrap variant="overline" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Job Number :</strong> {details?.est_doc_number ? `#${details?.est_doc_number}` : ''}
                              </Typography>
                            </Tooltip>
                            <Tooltip title={`Invoice Number: ${details?.doc_number ? `#${details?.doc_number}` : ''}`}>
                              <Typography noWrap variant="overline" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Invoice Number :</strong> {details?.doc_number ? `#${details?.doc_number}` : ''}
                              </Typography>
                            </Tooltip>
                          </>
                        ) : (
                          <Tooltip title={`Order Id: ${details?.doc_number ? `#${details?.doc_number}` : ''}`}>
                            <Typography noWrap variant="overline" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>Order Id :</strong> {details?.doc_number ? `#${details?.doc_number}` : ''}
                            </Typography>
                          </Tooltip>
                        )}
                      </Grid>

                      {details?.po_number && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Tooltip title={`PO Number: #${details?.po_number}`}>
                            <Typography noWrap variant="overline" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>PO Number :</strong> #{details?.po_number}
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}

                      {details?.avalara_code && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Tooltip title={`Avalara Id: ${details?.avalara_code}`}>
                            <Typography noWrap variant="overline" sx={{ display: 'block', color: '#fd6400' }}>
                              <strong>Avalara Id : {details?.avalara_code}</strong>
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}

                      {details?.design_order_id && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Tooltip title={`Design Order Id: #${details?.design_order_id}`}>
                            <Typography noWrap variant="overline" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>Design Order Id :</strong> #{details?.design_order_id}
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}

                      <Grid item xs={12} sm={6} md={4}>
                        <Tooltip title={`Created by: ${details?.added_by_name || ''}`}>
                          <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Created by :</strong> {details?.added_by_name || ''}
                          </Typography>
                        </Tooltip>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <Tooltip title={`Created on: ${details?.created_at ? moment.unix(details.created_at).format('MM-DD-YYYY hh:mm:ss A') : 'N/A'}`}>
                          <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Created on :</strong> {details?.created_at ? moment.unix(details.created_at).format('MM-DD-YYYY hh:mm:ss A') : 'N/A'}
                          </Typography>
                        </Tooltip>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        {(() => {
                          const clientName = details?.is_split_order && details?.for_parent_facility == 1 
                            ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || (Array.isArray(invoice) ? invoice[0]?.customer_name : invoice?.customer_name) || customerData?.customer_name || ''
                            : (Array.isArray(invoice) ? invoice[0]?.customer_name : invoice?.customer_name) || customerData?.customer_name || '';
                          return (
                            <Tooltip title={`Client Name: ${clientName}`}>
                              <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Client Name :</strong> {clientName}
                              </Typography>
                            </Tooltip>
                          );
                        })()}
                      </Grid>

                      {!(details?.is_split_order && details?.for_parent_facility == 1) && (
                        <>
                          <Grid item xs={12} sm={6} md={4}>
                            {(() => {
                              const clientAddress = [
                                (Array.isArray(invoice) ? invoice[0]?.customer_address : invoice?.customer_address) || customerData?.customer_address || '',
                                [
                                  (Array.isArray(invoice) ? invoice[0]?.customer_city : invoice?.customer_city) || customerData?.customer_city || details?.customer_city || '',
                                  (Array.isArray(invoice) ? invoice[0]?.customer_state : invoice?.customer_state) || customerData?.customer_state || details?.customer_state || '',
                                  (Array.isArray(invoice) ? invoice[0]?.customer_zipcode : invoice?.customer_zipcode) || customerData?.customer_zipcode || details?.customer_zipcode || '',
                                ].filter(Boolean).join(', ')
                              ].filter(Boolean).join(', ');
                              const clientAddressMultiline = [
                                (Array.isArray(invoice) ? invoice[0]?.customer_address : invoice?.customer_address) || customerData?.customer_address || '',
                                [
                                  (Array.isArray(invoice) ? invoice[0]?.customer_city : invoice?.customer_city) || customerData?.customer_city || details?.customer_city || '',
                                  (Array.isArray(invoice) ? invoice[0]?.customer_state : invoice?.customer_state) || customerData?.customer_state || details?.customer_state || '',
                                  (Array.isArray(invoice) ? invoice[0]?.customer_zipcode : invoice?.customer_zipcode) || customerData?.customer_zipcode || details?.customer_zipcode || '',
                                ].filter(Boolean).join(', ')
                              ].filter(Boolean).join('\n');
                              return (
                                <Tooltip title={`Client Address: ${clientAddress}`}>
                                  <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                    <strong>Client Address :</strong> {clientAddressMultiline}
                                  </Typography>
                                </Tooltip>
                              );
                            })()}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            {(() => {
                              const clientPhone = (Array.isArray(invoice) ? invoice[0]?.customer_phone : invoice?.customer_phone) || customerData?.customer_phone || '';
                              return (
                                <Tooltip title={`Client Phone: ${clientPhone}`}>
                                  <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                    <strong>Client Phone :</strong> {clientPhone}
                                  </Typography>
                                </Tooltip>
                              );
                            })()}
                          </Grid>
                        </>
                      )}

                      <Grid item xs={12} sm={6} md={4}>
                        <Tooltip title={`Project Name: ${details?.community_name || ''}`}>
                          <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Project Name :</strong> {details?.community_name || ''}
                          </Typography>
                        </Tooltip>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <Tooltip title={`Sales Rep: ${details?.sales_rep_names || ''}`}>
                          <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Sales Rep :</strong> {details?.sales_rep_names || ''}
                          </Typography>
                        </Tooltip>
                      </Grid>

                      {details?.job_category_name && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Tooltip title={`Job Type: ${details?.job_category_name}`}>
                            <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>Job Type :</strong> {details?.job_category_name}
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}

                      {details?.job_category_name === 'No Charge' && details?.no_charge_type_name && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Tooltip title={`No Charge Type: ${details?.no_charge_type_name}`}>
                            <Typography noWrap variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>No Charge Type :</strong> {details?.no_charge_type_name}
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}

                      {installationTypeSummary && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flexWrap: 'nowrap', width: 'fit-content', maxWidth: '100%' }}>
                            <Tooltip title={`Installation Type: ${installationTypeSummary.label}`}>
                              <Typography noWrap variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Installation Type :</strong> {installationTypeSummary.label}
                              </Typography>
                            </Tooltip>
                            <IconButton
                              size="small"
                              sx={{ flexShrink: 0 }}
                              onClick={() => {
                                setInstallationPopupData({
                                  label: installationTypeSummary.label,
                                  mixed: installationTypeSummary.mixed,
                                  rows: installationTypeSummary.popupRows,
                                })
                                setOpenInstallationTypeDialog(true)
                              }}
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          </Stack>
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <Stack sx={{ flexDirection: 'row', mt: 1 }}>
                          <Description />
                          <Typography
                            variant="body2"
                            sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', flexWrap: 'wrap', ml: 2, whiteSpace: 'pre-line' }}
                          >
                            {Array.isArray(details?.description_lines) && details.description_lines.length
                              ? details.description_lines.join('\n')
                              : details?.description || ''}
                          </Typography>
                        </Stack>
                        {details?.notes && (
                          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
                            <Tooltip title="Notes">
                              <Notes sx={{ color: 'error.main' }} />
                            </Tooltip>
                            <Typography variant="caption" sx={{ flexWrap: 'wrap', color: 'error.main', whiteSpace: 'pre-line' }}>
                              {Array.isArray(details?.notes_lines) && details.notes_lines.length
                                ? details.notes_lines.join('\n')
                                : details?.notes || ''}
                            </Typography>
                          </Stack>
                        )}
                        {details?.no_charge_reason && (
                          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
                            <Typography variant="caption" sx={{ color: 'yellow' }}>
                              No Charge Reason:
                            </Typography>
                            <Typography variant="caption" sx={{ flexWrap: 'wrap', color: 'yellow', whiteSpace: 'pre-line' }}>
                              {details?.no_charge_reason}
                            </Typography>
                          </Stack>
                        )}
                        {Number(details?.change_order) === 1 && details?.change_order_reason && (
                          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
                            <Typography variant="caption" sx={{ color: 'yellow' }}>
                              Change Order Reason:
                            </Typography>
                            <Tooltip
                              title={details.change_order_reason.length > 30 ? details.change_order_reason : ''}
                              disableHoverListener={details.change_order_reason.length <= 30}
                            >
                              <Typography
                                component="span"
                                variant="caption"
                                sx={{ flexWrap: 'wrap', color: 'yellow', whiteSpace: 'pre-line'}}
                              >
                                {details.change_order_reason.length > 30
                                  ? `${details.change_order_reason.slice(0, 30)}...`
                                  : details.change_order_reason}
                              </Typography>
                            </Tooltip>
                          </Stack>
                        )}
                      </Grid>
                    </Grid>
                    </Box>
                  )}
                  {currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab != 'Completed' && data?.status != 3  && details?.for_parent_facility != 2 && !isSalesOrderVoided && (
                    <Stack
                      spacing={{ xs: 2, md: 2 }}
                      direction={'row'}
                      alignItems="center"
                      justifyContent="flex-end"
                    >                      
                        {data?.status === 1 && Number(data?.hold) !== 1 ? <Button size="small" variant="outlined"
                          onClick={() => {
                            setOpenRejectPopup(true)
                            setReason('')
                            setRejectFile(null)
                          }}
                          disabled={user.user_type == 3 ? true : false}
                          sx={{ color: theme.palette.error.main }} >
                          Reject
                        </Button>
                          : data?.status === 9 && !isSalesOrderVoided ? <Button size="small" variant="outlined"
                            onClick={() => {
                              // handleReopenJob(details?.id,details?.request_id)
                              setReOpenJob(true)
                            }}
                          // disabled={user.user_type == 3 ? true : false}
                          sx={{ color: theme.palette.success.main }} >
                          Reopen
                        </Button> : ''}
                     {data?.status != 9 && !isSalesOrderVoided && Number(data?.is_rejected) !== 1 ? <Button
                        onClick={() => {
                          setOpenHoldPopup(true)
                        }}
                        disabled={user.user_type == 3 ? true : false}
                        sx={{
                          borderRadius: 20,
                          backgroundColor: theme.palette.warning.main,
                          color: 'black',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: theme.palette.warning.dark,
                            boxShadow: 'none',
                          },
                        }}
                        variant="contained"
                      >
                        {data?.hold === 0
                          ? 'Move to Hold'
                          : 'Release from Hold'}
                      </Button>:''}
                    </Stack>
                  )}
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={{ xs: 2, md: 0 }}
                    alignItems="center"
                    justifyContent={'space-between'}
                  >
                    {/* {value?.value &&
                    (details?.job_category_name !== 'Time & Material') &&
                    ((data?.status !== 1 && data?.status !== 0) || data?.hold === 1) */}
                    {
                    // value?.value &&
                    ((details?.allInstallationCompleted == 1) || (!hasJobPermission) || data?.status === 9 || isSalesOrderVoided || (details?.job_category_name === 'Time & Material' && data?.status === 3 && details?.project_category !== 12) ||
                    (details?.job_category_name !== 'Time & Material' &&
                      ((data?.status !== 1 && data?.status !== 0) || data?.hold === 1) 
                      && data?.status !== 2  // Now options show on Production tab (status 2)
                    ))
                     ? (
                      <Button
                      // disabled={data?.status === 9}
                        sx={{
                          width: '40%',                          
                          background: isSalesOrderVoided || data?.status === 9 ? '#c9302c' : colors[value?.id],
                          color: '#ffffff',
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                      >
                        {' '}
                        {isSalesOrderVoided ? 'Void' : data?.status === 9 ? 'Rejected' : value?.value}{' '}
                      </Button>
                    ) : (
                      <TextField
                        select
                        size="small"
                        value={value?.value}
                        sx={{
                          width: '35%',
                          background: colors[value?.id],
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                      >
                        
                        {options.map((optio) => (
                          <MenuItem
                            onClick={() => {
                              if(isLoggedIn && (optio.id == 3)){
                                enqueueSnackbar('Please clock out from all ongoing jobs before proceeding', { variant: 'warning' })
                                return;
                              }else{
                                // setValue(optio)
                                // handleUpdateStatus(optio.id)


                                
                                // Check subtask validation first (priority)
                                const isTimeAndMaterialJob = details?.project_category === 12;
                                if (isTimeAndMaterialJob) {
                                  const hasEmptySubTask = projectTask?.some(
                                    (task) => task.is_manually_added === 1 && task.subtask_count === 0
                                  );
                                
                                  if (hasEmptySubTask) {
                                    setOpenSubtaskValidationPopup(true);
                                    return; // stop further execution
                                  }
                                }

                                // Only check service workflow condition if subtask validation passes for all tasks
                                const hasServiceWorkflowIssue = projectTask?.some(
                                  (task) => task.service_id &&isTimeAndMaterialJob && !task.service_workflow && task.subtask_count === 0
                                );
                                
                                if (hasServiceWorkflowIssue) {
                                  setSelectedOption(optio);
                                  setOpenServiceWorkflowConfirmation(true);
                                  return; // stop further execution
                                }
                                //Autocomplete for status
                                handlePopup(optio)
                              }
                            }}
                            disabled={
                              (option.value === 'Completed' && details?.project_category !== 12) || loadingJobCost ||
                              user.user_type == 3 || details?.for_parent_facility == 2
                                ? true
                                : false
                            }
                            key={optio.value}
                            value={optio.value}
                          >
                            {optio.value}
                          </MenuItem>
                        ))}
                      </TextField>
                      )
                    }
                    <ConfirmationPopup
                      open={openPopup}
                      handleClick={() => {
                        handleUpdateStatus(status)
                      }}
                      handleClose={() => {
                        setOpenPopup(!openPopup)
                      }}
                      message={
                        status?.id === 3
                          ? 'If we complete all the related task and sub tasks will complete as well'
                          // : `All tasks and subtasks have been moved to the ${status?.value} state`
                          : `Job status will be changed to ${status?.value}`
                      }
                    />
                    <Dialog
                      aria-describedby="job-complete-clock-in-dialog"
                      TransitionComponent={ClockInTransition}
                      transitionDuration={500}
                      open={openService}
                      PaperProps={{
                        sx: {
                          width: { xs: '90%', sm: '60%', md: '70%' },
                          p: 2,
                          borderRadius: 2,
                        },
                      }}
                    >
                      <DialogContent
                        sx={{
                          mt: 1,
                          px: 2,
                          overflowY: 'auto',
                          overflowX: 'auto',
                          maxHeight: 500,
                        }}
                      >
                        <Table size="small" sx={{ minWidth: 500 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell align="center" sx={{ width: '30%', py: 1 }}>
                                <strong>Member</strong>
                              </TableCell>
                              <TableCell align="center" sx={{ width: '25%', py: 1 }}>
                                <Box>
                                  <Typography variant="subtitle2" fontWeight="bold">
                                    Time
                                  </Typography>
                                  <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                                    (HH:MM)
                                  </Typography>
                                </Box>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {visibleClockInMembers.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={2} align="center">
                                  No job members available
                                </TableCell>
                              </TableRow>
                            ) : (
                              visibleClockInMembers.map((item) => (
                                <TableRow key={item.rowKey} sx={{ mt: 2, height: 44 }}>
                                  <TableCell align="center">
                                    {/* {item.subtask_name ? `${item.name} - ${item.subtask_name}` : item.name} */}
                                    {item.subtask_name
                                      ? `${item.name} - ${item.task_name || 'Task'} - ${item.subtask_name}`
                                      : item.task_name
                                        ? `${item.name} - ${item.task_name}`
                                        : item.name}
                                  </TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1} justifyContent="center">
                                      <TextField
                                        name="hours"
                                        label="Hours"
                                        placeholder="01"
                                        size="small"
                                        sx={{ width: 80 }}
                                        inputProps={{ min: 0 }}
                                        onKeyDown={(e) => {
                                          const allowedKeys = [
                                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                                          ]
                                          if (!allowedKeys.includes(e.key)) {
                                            e.preventDefault()
                                          }
                                        }}
                                        onChange={(e) => {
                                          const h = parseInt(e.target.value || '0', 10)
                                          const m = parseInt(
                                            e.target.closest('tr').querySelector('input[name="minutes"]')?.value || '0',
                                            10,
                                          )
                                          const totalMinutes = h * 60 + m
                                          const decimal = Math.round((totalMinutes / 60) * 10000) / 10000
                                          updateClockInInput(item.rowKey, {
                                            hour: decimal,
                                            hourly_rate: item.hourly_rate,
                                            userId: item.userId || item.user_id,
                                            staff_id: item.staff_id,
                                            task_id: item.task_id,
                                            subtask_id: item.subtask_id,
                                            subtask_name: item.subtask_name,
                                          })
                                        }}
                                      />
                                      <TextField
                                        label="Minutes"
                                        name="minutes"
                                        placeholder="30"
                                        size="small"
                                        sx={{ width: 80 }}
                                        inputProps={{ min: 0, max: 60 }}
                                        onKeyDown={(e) => {
                                          const allowedKeys = [
                                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                                          ]
                                          if (!allowedKeys.includes(e.key)) {
                                            e.preventDefault()
                                          }
                                        }}
                                        onInput={(e) => {
                                          const value = parseInt(e.target.value || '0', 10)
                                          if (value > 60) {
                                            e.target.value = 60
                                          } else if (value < 0) {
                                            e.target.value = 0
                                          }
                                        }}
                                        onChange={(e) => {
                                          let m = parseInt(e.target.value || '0', 10)
                                          let h = parseInt(
                                            e.target.closest('tr').querySelector('input[name="hours"]')?.value || '0',
                                            10,
                                          )
                                          const totalMinutes = h * 60 + m
                                          const decimal = Math.round((totalMinutes / 60) * 10000) / 10000
                                          updateClockInInput(item.rowKey, {
                                            hour: decimal,
                                            hourly_rate: item.hourly_rate,
                                            userId: item.userId || item.user_id,
                                            staff_id: item.staff_id,
                                            task_id: item.task_id,
                                            subtask_id: item.subtask_id,
                                            subtask_name: item.subtask_name,
                                          })
                                        }}
                                      />
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </DialogContent>
                      <Stack direction="row" justifyContent="flex-end" spacing={2} px={3} mt={1} pb={2}>
                        <Button
                          onClick={() => {
                            handleCloseClockIn()
                            enqueueSnackbar('Operation was cancelled', { variant: 'error' })
                          }}
                          sx={{
                            background: '#BB2525',
                            color: '#fff',
                            '&:hover': {
                              background: '#FF8F8F',
                            },
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleJobCompleteClockIn}
                          disabled={isClockInDisabled}
                        >
                          {clockInLoading ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            'Clock In'
                          )}
                        </Button>
                      </Stack>
                    </Dialog>
                      <Dialog
                        open={openInstallationTypeDialog}
                        onClose={() => {
                          setOpenInstallationTypeDialog(false)
                          setInstallationPopupData(null)
                        }}
                        maxWidth="sm"
                        fullWidth
                      >
                        <DialogTitle>Installation Type: {installationPopupData?.label}</DialogTitle>
                        <DialogContent dividers>
                          {installationPopupData?.rows?.map((row, i) => (
                            <Typography key={i} variant="body2" sx={{ py: 0.5 }}>
                              {row.name}
                              {installationPopupData.mixed && <> — {row.type ? getInstallationStatusLabel(row.type) : '—'}</>}
                            </Typography>
                          ))}
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                              setOpenInstallationTypeDialog(false)
                              setInstallationPopupData(null)
                            }}
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {status?.id === 3 && (details?.project_category === 15 && details?.is_split_order !== 1) ? (
                        <Dialog open={openPopupComplete} onClose={() => setOpenPopupComplete(false)}>
                          <DialogContent sx={{mb:-2}}>
                            <Stack direction="column" spacing={2}>
                              <Typography variant='h6'>Are you sure you want to complete this Job?</Typography>
                              <Alert severity="info">
                                If this job is completed, stock will be added to the selected Catalog. Once completed, this job & sales order will move directly to the Completed tab.
                              </Alert>
                            </Stack>
                          </DialogContent>
                          <DialogActions>
                            <Button variant='outlined' color='inherit' onClick={() => setOpenPopupComplete(false)}>No</Button>
                            <Button
                              variant="contained"
                              sx={{ boxShadow: 'none' }}
                              onClick={() => {
                                setOpenPopupComplete(false);
                                handleUpdateStatus(status);
                              }}
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                      ) : (
                        <ConfirmationPopup
                          isComplete={true}
                          setCompleteStatus={setCompleteStatus}
                          noServiceNoTask={
                            details?.noServiceNoTask === 1 ? 1 :
                            (() => {
                              const allServices = [...(requestServices || []), ...(rfpServices || [])];
                              // Check if all services have both task toggle and install toggle off
                              const allServicesBothTogglesOff = allServices.length > 0 && 
                                allServices.every(service => service.makeAsTask === 0 && service.makeInstallCard === 0);
                              // For category 13, also check if all install cards are off
                              const isCategory13AllInstallCardsOff = details?.project_category === 11 &&
                                (allServices.length === 0 || allServices.every(service => service.makeInstallCard === 0));
                              return (allServicesBothTogglesOff || isCategory13AllInstallCardsOff) ? 1 : (details?.noServiceNoTask || 0);
                            })()
                          }
                          projectCategory={details?.project_category}
                          details={details}
                          projectId={id}
                          projectTasks={projectTask}
                          open={openPopupComplete}
                          handleClick={(stockData) => {
                            handleUpdateStatus(status, stockData)
                          }}
                          hideCancel={true}
                        />
                      )}
                    {/* <ConfirmationPopup
                    isComplete={true}
                    setCompleteStatus={setCompleteStatus}
                    noServiceNoTask={details?.noServiceNoTask}
                      open={openPopupComplete}
                      handleClick={() => {
                        handleUpdateStatus(status)
                      }}
                       hideCancel={true}

                      // handleClose={() => {
                      //   setOpenPopupComplete(!openPopupComplete)
                      // }}
                      // message={`All tasks and subtasks have been moved to the ${status?.value} state`}
                    /> */}
                    <Dialog
                      open={openHoldPopup && Number(data?.status) !== 9 && Number(data?.is_rejected) !== 1}
                      onClose={() => {
                        setOpenHoldPopup(false);
                        setHoldReason('');
                      }}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                      BackdropProps={{ invisible: true }}
                    >
                      <DialogTitle id="alert-dialog-title">
                        {data?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          {data?.hold === 1
                            ? 'You want to move this Job from Hold.'
                            : 'You want to move this Job to Hold.'}
                        </DialogContentText>
                        {(data?.hold === 0) ? (
                          <TextField
                            sx={{ width: 400, mt: 2 }}
                            label="Reason"
                            type="text"
                            multiline
                            minRows={3}
                            maxRows={7}
                            value={holdReason}
                            onChange={(e) => {
                              setHoldReason(e.target.value);
                              if (holdReasonError) setHoldReasonError('');
                            }}
                            error={Boolean(holdReasonError)}
                            helperText={holdReasonError}
                          />
                        ) : ''}
                      </DialogContent>
                      <DialogActions>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={async () => {
                            if ((data?.hold === 0) && !holdReason.trim()) {
                              setHoldReasonError('Reason is required to put this Job on Hold.');
                              return;
                            }

                            setIsSubmittingHold(true);
                            await handleUpdateHoldStatus(holdReason);
                            setIsSubmittingHold(false);
                            setOpenHoldPopup(false);
                            setHoldReason('');
                            setHoldReasonError('');
                          }}
                          disabled={isSubmittingHold}
                        >
                          {isSubmittingHold ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            'OK'
                          )}
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setOpenHoldPopup(false);
                            setHoldReason('');
                          }}
                          sx={{ color: theme.palette.error.main }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={openRejectPopup && Number(data?.hold) !== 1}
                      onClose={() => {
                        if (isSubmittingReject || isUploadingRejectFile) return
                        setOpenRejectPopup(false)
                      }}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                      BackdropComponent={Backdrop}
                      BackdropProps={{ invisible: true }}
                      PaperProps={{
                        sx: {
                          width: 700,
                          borderRadius: 2,
                          bgcolor: '#0f1b1e',
                          border: '1px solid rgba(255,255,255,0.12)',
                        },
                      }}
                    >
                      <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600, color: '#fff', pb: 1 }}>
                        {"Are you sure ?"}
                      </DialogTitle>
                      <DialogContent sx={{ pt: 0 }}>
                        <DialogContentText id="alert-dialog-description" sx={{ color: 'grey.400', mb: 2 }}>
                          <Box component="span" sx={{ color: 'warning.main', fontWeight: 600 }}>
                            Rejecting this will move the Job and sales order to Rejected. Do you want to continue?
                          </Box>
                        </DialogContentText>

                        <TextField
                          fullWidth
                          label="Reason For Rejection"
                          type="text"
                          multiline
                          minRows={3}
                          maxRows={7}
                          onInput={(event) => setReason(event.target.value)}
                          sx={{
                            mb: 2,
                            bgcolor: 'rgba(255,255,255,0.05)',
                            borderRadius: 1,
                            input: { color: '#fff' },
                            '& .MuiInputLabel-root': { color: 'grey.400' },
                          }}
                        />

                        <UploadMultiFile
                          showPreview
                          files={rejectFile ? [rejectFile] : []}
                          // accept="image/*,application/pdf"
                          maxSize={1024 * 1024 * 1024}
                          multiple={false}
                          onDrop={handleRejectFileDrop}
                          onRemove={() => setRejectFile(null)}
                          onRemoveAll={() => setRejectFile(null)}
                          isUploading={isUploadingRejectFile}
                          sx={{ mt: 1 }}
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={handleRejectJob}
                          disabled={isSubmittingReject || isUploadingRejectFile}
                          sx={{
                            color: theme.palette.background.paper,
                            fontWeight: 600,
                            px: 3,
                          }}
                        >
                          {isSubmittingReject ? <CircularProgress size={20} color="inherit" /> : 'OK'}
                        </Button>

                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setOpenRejectPopup(false)
                            setReason('')
                            setRejectFile(null)
                          }}
                          sx={{ color: theme.palette.error.main }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Dialog
                      open={openSubtaskValidationPopup}
                      onClose={() => setOpenSubtaskValidationPopup(false)}
                      aria-labelledby="subtask-validation-dialog-title"
                      aria-describedby="subtask-validation-dialog-description"
                    >
                      <DialogTitle id="subtask-validation-dialog-title">
                        Cannot Change Status
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="subtask-validation-dialog-description">
                        Each task must have at least one sub task to change status
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button 
                          onClick={() => setOpenSubtaskValidationPopup(false)}
                          variant="contained"
                          color="primary"
                        >
                          OK
                        </Button>
                      </DialogActions>
                    </Dialog>
                    
                    <Dialog
                      open={openServiceWorkflowConfirmation}
                      onClose={() => setOpenServiceWorkflowConfirmation(false)}
                      aria-labelledby="service-workflow-confirmation-dialog-title"
                      aria-describedby="service-workflow-confirmation-dialog-description"
                    >
                      <DialogTitle id="service-workflow-confirmation-dialog-title">
                        Confirm Status Change
                      </DialogTitle>
                      <DialogContent>
                        {(() => {
                          const affectedTasks = projectTask?.filter(task => task.service_id && !task.service_workflow) || [];
                          const isSingle = affectedTasks.length === 1;
                          
                          return (
                            <>
                              <DialogContentText id="service-workflow-confirmation-dialog-description">
                                {isSingle 
                                  ? "The following task has no service workflow assigned:"
                                  : "The following tasks have no service workflow assigned:"
                                }
                              </DialogContentText>
                              <Box sx={{ mt: 2 }}>
                                {affectedTasks.map((task, index) => (
                                  <Typography key={index} variant="body2" sx={{ mb: 1, fontWeight: 'medium' }}>
                                    • {task.name || `Task ${task.id}`}
                                  </Typography>
                                ))}
                              </Box>
                              <DialogContentText sx={{ mt: 2 }}>
                                Are you sure you want to change the status?
                              </DialogContentText>
                            </>
                          );
                        })()}
                      </DialogContent>
                      <DialogActions>
                        <Button 
                          onClick={() => setOpenServiceWorkflowConfirmation(false)}
                          variant="outlined"
                          color="error"
                        >
                          Cancel
                        </Button>
                        <Button 
                          onClick={() => {
                            setOpenServiceWorkflowConfirmation(false);
                            handlePopup(selectedOption);
                          }}
                          variant="contained"
                          color="primary"
                        >
                          Confirm
                        </Button>
                      </DialogActions>
                    </Dialog>
                    
                    <Stack direction={'row'} spacing={1}>
                      {/* {details?.project_category === 12 && Number(details?.isReview) === 2 && (
                        <Button
                          onClick={handleOpenTmDraftConfirm}
                          disabled={loadingJobCost || updatingTmDraft}
                          sx={{ borderRadius: 20, boxShadow: 'none' }}
                          color="warning"
                          variant="contained"
                        >
                          {Number(details?.tm_review_draft || 0) === 1 ? 'Release From Draft' : 'Move to Draft'}
                        </Button>
                      )} */}
                      <ConfirmationPopup
                        open={openTmDraftConfirm}
                        handleClick={handleToggleTmDraft}
                        handleClose={() => setOpenTmDraftConfirm(false)}
                        message={
                          Number(pendingTmDraftValue) === 1
                            ? 'Are you sure you want to move this TM job to Draft?'
                            : 'Are you sure you want to release this TM job from Draft?'
                        }
                        loading2={updatingTmDraft}
                      />
                      {loadingJobCost ? (
                        <Stack
                          flexDirection={'row'}
                          alignItems="center"
                          justifyContent="center"
                        >
                          {/* <Typography variant='subtitle2'>Loading Job Cost...</Typography> */}
                          <CircularProgress
                            color="primary"
                            variant="indeterminate"
                            size="20px"
                          />
                        </Stack>
                      ) : (
                        user.user_type !== 3 && (
                          <>
                            {popupOn?<Button
                              disabled={
                                explodedPermissions?.some((permission) =>
                                  ['Manage Job Cost'].includes(permission),
                                )
                                  ? false
                                  : true
                              }
                              onClick={()=>handleClickforProject(id,'Labor')}
                              // onClick={() => {
                              //   // if(details?.job_category_name == 'Time & Material'){ 
                              //   //   const params = details.id
                              //   //   navigate(`${PATH_DASHBOARD.project.jobCost}/${id}`,
                              //   //     {state: { request: params,currentTab : currentTab }});
                              //   // }else{
                              //     navigate(
                              //       PATH_DASHBOARD.project.recipeCost + '/' + id,
                              //       { state: { currentTab: currentTab } },
                              //     )
                              //   // }
                              // }}
                              sx={{ borderRadius: 20 }}
                              variant="outlined"
                            >
                              Job Cost
                            </Button>:
                            <Button
                            disabled={
                              explodedPermissions?.some((permission) =>
                                ['Manage Job Cost'].includes(permission),
                              )
                                ? false
                                : true
                            }
                            // onClick={()=>handleClickforProject(id,currentTab)}
                            onClick={() => {
                              // if(details?.job_category_name == 'Time & Material'){ 
                              //   const params = details.id
                              //   navigate(`${PATH_DASHBOARD.project.jobCost}/${id}`,
                              //     {state: { request: params,currentTab : currentTab }});
                              // }else{
                                navigate(
                                  PATH_DASHBOARD.project.recipeCost + '/' + id,
                                  { state: { currentTab: 'Labor' } },
                                )
                              // }
                            }}
                            sx={{ borderRadius: 20 }}
                            variant="outlined"
                          >
                            Job Cost
                          </Button>
                            }
                          </>
                        )
                      )}

                      <Tooltip
                        title={
                          details?.status === 0
                            ? 'Request has been deleted'
                            : ''
                        }
                      >
                        <Button
                          // onClick={() => setOpenInvoice(!openInvoice)}
                          onClick={() => {
                            details?.status == 0
                              ? ''
                              : details?.is_split_order == 1 ?
                              navigate(
                                `/dashboard/split-order/split-sales-order/view/${details?.id}`,
                                {
                                  state: {
                                    fromProjects: true,
                                    projectId: id,
                                    currentTab,
                                  },
                                }
                              )
                              :
                               navigate(
                                  `/dashboard/official-request/view/${details?.id}`,
                                  {
                                    state: {
                                      fromProjects: true,
                                      projectId: id,
                                      currentTab,
                                    },
                                  }
                                )
                          }}
                          // disabled={details?.status === 0}
                          disabled={loadingJobCost}
                          sx={{
                            borderRadius: 20,
                            background: details?.status == 0 ? '#ed2424' : '',
                            border: details?.status == 0 ? '#ed2424' : '',
                            color: details?.status == 0 ? '#ffff' : '',
                          }}
                          variant="outlined"
                        >
                          Sales Order Details
                        </Button>
                      </Tooltip>
                      {details && details.is_split_order !== 1 && availableRevertOptions.length > 0 && hasJobPermission && details.installation_acceptance !== 1 && !isSalesOrderVoided && (
                        <>
                          <Button
                            variant="outlined"
                            size="small"
                            color="warning"
                            onClick={handleOpenRevertStatusDialog}
                            disabled={isSubmittingStatusRevert}
                            sx={{ borderRadius: 20 }}
                          >
                            Revert Status
                          </Button>
                          <RevertStatusDialog
                            open={openRevertStatusDialog}
                            onClose={handleCloseRevertStatusDialog}
                            options={availableRevertOptions}
                            selectedKey={selectedRevertOptionKey}
                            onSelect={setSelectedRevertOptionKey}
                            onConfirm={handleConfirmRevertStatus}
                            isSubmitting={isSubmittingStatusRevert}
                          />
                        </>
                      )}
                      {// secTab === 'Tasks'&& details?.job_category_name!='Service only' &&
                      user.user_type !== 3 &&
                        currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                        secTab === 'Tasks' &&
                        currentTab != 'Completed' &&
                        currentTab != 'Hold' &&
                        data?.status != 3 &&
                        data?.status != 9 &&
                        details?.for_parent_facility != 2 &&
                        data?.hold != 1 &&
                        !isSalesOrderVoided && (
                          <Button
                            onClick={() => {
                              setAdd(!add)
                            }}
                            disabled={user.user_type == 3 ? true : false}
                            sx={{ borderRadius: 20 }}
                            variant="contained"
                          >
                            Add Task
                          </Button>
                        )}
                      {/* && details?.job_category_name!='Service only' */}
                      {secTab === 'Members' &&
                        user.user_type !== 3 &&
                        currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                        currentTab != 'Completed' &&
                        currentTab != 'Hold' &&
                        data?.status != 9 &&
                        details?.for_parent_facility != 2 &&
                        // data?.status != 3 &&
                        data?.hold != 1 &&
                        !isSalesOrderVoided && (
                          <Button
                            disabled={user.user_type == 3 ? true : false}
                            onClick={() => {
                              setAddMember(true)
                            }}
                            sx={{ borderRadius: 20 }}
                            variant="contained"
                          >
                            Add Member
                          </Button>
                        )}
                    </Stack>
                  </Stack>
                  <Stack sx={{ alignItems: 'center', mb: 2 }} spacing={2}>
                    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
                      <Tabs
                        value={secTab}
                        scrollButtons="auto"
                        variant="scrollable"
                        allowScrollButtonsMobile
                        onChange={handleTab}
                        sx={{
                          width: '100%',
                          '& .MuiTabs-scrollButtons': {
                            '&.Mui-disabled': {
                              opacity: 0.3,
                            },
                          },
                          '& .MuiTabs-flexContainer': {
                            gap: 1,
                          },
                          '& .MuiTab-root': {
                            minWidth: 'auto',
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            padding: '6px 16px',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                            textTransform: 'none',
                            [theme.breakpoints.down('sm')]: {
                              padding: '6px 12px',
                              fontSize: '0.7rem',
                            },
                          },
                          '& .MuiTabs-scroller': {
                            overflow: 'auto !important',
                            '&::-webkit-scrollbar': {
                              height: 6,
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: 'rgba(0,0,0,0.1)',
                              borderRadius: 3,
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: 'rgba(0,0,0,0.3)',
                              borderRadius: 3,
                              '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.5)',
                              },
                            },
                          },
                        }}
                      >
                        {TABS.map((tab) => (
                          <Tab
                            disableRipple
                            key={tab.value}
                            label={
                              <Typography variant="overline" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                {capitalCase(tab.value)}
                                {tab.value === 'Design Notes' && designNotesHasNew && (
                                  <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                                )}
                                {tab.value === 'Job Notes' && jobNotesHasNew && (
                                  <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                                )}
                              </Typography>
                            }
                            icon={tab.icon}
                            value={tab.value}
                          />
                        ))}
                      </Tabs>
                    </Box>

                    {TABS.map((tab) => {
                      const isMatched = tab.value === secTab

                      return (
                        isMatched && (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              ...(secTab === 'Attachments'
                                ? { width: '80%' }
                                : secTab === 'Locations'
                                ? { width: '100%' }
                                : { width: '100%' }),
                            }}
                            key={tab.value}
                          >
                            {tab.component}
                          </Box>
                        )
                      )
                    })}
                  </Stack>
                </Stack>
              </Grid>
              <Grid key={2} item xs={12} md={4}>
                <Card sx={{ minHeight: 100 }}>
                  <Stack width={'100%'}>
                    {/* <Box component={'image'}>
                <img
                  src={
                    data?.cover_image && data?.cover_image !=='DefaultThumbnailURL' ? data?.cover_image : 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
                  }
                  alt="img"
                />
              </Box> */}
                  {designs?.filter((row) => isApprovedDesignPreview(row))?.length <= 0 ? 
                    <Box component={'image'}>
                      <img
                        src={'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'}
                        alt="img"
                      />
                    </Box>
                  :
                    <Slider {...settings}>
                      {designs
                        .filter((row) => isApprovedDesignPreview(row))
                        ?.map((item) => (
                          <Box sx={{ position: 'relative' }}>
                            {isGoogleViewerDesign(item) ? (
                              <Box sx={{ position: 'relative', width: '100%', height: 280 }}>
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(item.name)}&embedded=true`}
                                  title={item.name}
                                  width="100%"
                                  height="100%"
                                  frameBorder="0"
                                  style={{ border: 'none', pointerEvents: 'none' }}
                                />
                              </Box>
                            ) : (
                              <CarouselImgStyle src={item.name} />
                            )}
                            {/* <Box
                        sx={{
                          top: 0,
                          width: '100%',
                          height: '100%',
                          position: 'absolute',
                          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
                        }}
                      /> */}
                            <CardContent
                              sx={{
                                left: 0,
                                bottom: -40,
                                maxWidth: '80%',
                                textAlign: 'left',
                                position: 'absolute',
                                color: 'common.white',
                              }}
                            >
                              <Typography
                                noWrap
                                variant="h5"
                                sx={{ mt: 1, mb: 3 }}
                              >
                                {
                                  details?.job_category_name == 'Service only' ? 'Designs':
                                'Approved Designs'
                                }
                              </Typography>
                            </CardContent>
                          </Box>
                        ))}
                    </Slider>
                  }
                    <Box>
                      <Typography
                        variant="overline"
                        sx={{
                          mt: 3,
                          ml: 2,
                          display: 'block',
                          // color: 'text.secondary',
                        }}
                      >
                        Project Completion:
                        {singleProjectData?.result.completion}%
                      </Typography>

                      {/* {singleProjectData && <Sliderw
                    aria-label="Percentage"
                    defaultValue={singleProjectData.result.completion}
                    getAriaValueText={valuetext}
                    onChange={updateStatus}
                    valueLabelDisplay="auto"
                    //  step={10}
                    marks
                    min={10}
                    max={100}
                  />} */}
                    </Box>
                    <Box
                      sx={{
                        my: 2,
                        mx: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Stack width={'100%'} spacing={3}>
                        <Stack
                          direction={'row'}
                          justifyContent={'space-between'}
                          alignItems={'center'}
                        >
                          <Typography variant="h4" sx={PRESERVE_WHITESPACE_SX}>{data?.name}</Typography>
                          {currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                            currentTab != 'Completed' &&
                            currentTab != 'Hold' &&
                            data?.status != 3 &&
                            data?.status != 9 &&
                            details?.for_parent_facility != 2 &&
                            data?.hold != 1 &&
                            (details?.job_category_name != 'Service only' ||
                              data?.status !== 3) && (
                              <>
                                {' '}
                                <MoreVert
                                  ref={ref}
                                  sx={{ width: 25 }}
                                  onClick={() => setIsOpen(true)}
                                />
                                <Menu
                                  open={isOpen}
                                  anchorEl={ref.current}
                                  onClose={() => setIsOpen(false)}
                                  PaperProps={{
                                    sx: { width: 200, maxWidth: '100%' },
                                  }}
                                  anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                  }}
                                  transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                  }}
                                >
                                  {details?.job_category_name !=
                                    'Service only' && (
                                    <MenuItem
                                      onClick={() => setAdd(true)}
                                      disabled={
                                        user.user_type == 3 ? true : false
                                      }
                                    >
                                      <ListItemText
                                        primary="Add Task"
                                        primaryTypographyProps={{
                                          variant: 'body2',
                                        }}
                                      />
                                    </MenuItem>
                                  )}

                                  {data?.status !== 3 && (
                                    <MenuItem
                                      // component={RouterLink}
                                      // to={`${PATH_DASHBOARD.user.root}/${paramCase(userName)}/edit`}
                                      disabled={
                                        explodedPermissions?.some(
                                          (permission) =>
                                            ['Edit Jobs'].includes(permission),
                                        )
                                          ? false
                                          : true
                                      }
                                      onClick={() => {
                                        setIsEdit(true)
                                      }}
                                      // sx={{ color: 'text.secondary' }}
                                    >
                                      <ListItemText
                                        primary="Edit Job"
                                        primaryTypographyProps={{
                                          variant: 'body2',
                                        }}
                                      />
                                    </MenuItem>
                                  )}
                                  {/* <MenuItem
                        // component={RouterLink}
                        // to={`${PATH_DASHBOARD.user.root}/${paramCase(userName)}/edit`}
                        sx={{ color: 'text.secondary' }}
                      >
                        <ListItemText
                          primary="Activate Project"
                          primaryTypographyProps={{ variant: 'body2' }}
                        />
                      </MenuItem> */}
                                </Menu>
                              </>
                            )}
                        </Stack>
                        <Typography variant="caption" sx={{whiteSpace: 'pre-wrap'}}>
                          {data?.description}
                        </Typography>
                        <Stack
                          display={'flex'}
                          direction={'row'}
                          justifyContent={'space-between'}
                        >
                          <Grid container>
                            <Grid item xs={2}>
                              <Stack spacing={1.7}>
                                <Groups sx={{ width: 17 }} />
                                <Attachment sx={{ width: 15 }} />
                                <CheckCircle sx={{ width: 15 }} />
                                <Error sx={{ width: 17 }} />
                              </Stack>
                            </Grid>
                            <Grid item xs={8}>
                              <Stack spacing={2}>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Members')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Members
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Attachments')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Attachment
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Completed Tasks
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Pending Tasks
                                </Typography>
                              </Stack>
                            </Grid>
                            <Grid item xs={2}>
                              <Stack spacing={2}>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Members')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.member_count}
                                </Typography>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Attachments')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.attachment_count}
                                </Typography>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.completed_task_count}
                                </Typography>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.pending_task_count}
                                </Typography>
                              </Stack>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                </Card>
                <Box sx={{ width: '100%', mt: 2 }}>
              {isSalesOrderVoided && details?.reason ? (
                <Box
                  sx={{
                    backgroundColor: theme.palette.mode === 'light' ? '#f5f5f5' : '#122227',
                    border: `1px solid ${theme.palette.mode === 'light' ? '#e0e0e0' : '#2a3b40'}`,
                    borderRadius: 1,
                    p: 2,
                    mb: 2,
                    maxWidth: '100%',
                    wordBreak: 'break-word',
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: theme.palette.error.main,
                      fontWeight: 'bold',
                      mb: 1,
                    }}
                  >
                    Void Reason
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: theme.palette.text.primary,
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                    }}
                  >
                    {details.reason}
                  </Typography>
                </Box>
              ) : (details?.reason || details?.reject_file) ? (
                <Stack display={'flex'} direction={'column'} gap={1}>
                  <Box
                    sx={{
                      backgroundColor: '#122227',
                      border: '1px solid #2a3b40',
                      borderRadius: 1,
                      p: 2,
                      mb: 2,
                      maxWidth: '100%'
                    }}
                  >
                    <Stack display={'flex'} direction={'row'} gap={1}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: theme.palette.error.main,
                          fontWeight: 'bold',
                          mb: 1
                        }}
                      >
                        Reject Reason
                      </Typography>
                      {details?.reason && (
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#fff',
                            whiteSpace: 'pre-line',
                            mb: details?.reject_file ? 2 : 0
                          }}
                        >
                          {details?.reason}
                        </Typography>
                      )}
                    </Stack>
                    {details?.reject_file && (
                      details?.reject_file_type === 'application/pdf' ? (
                        <Button
                          variant="outlined"
                          color="primary"
                          fullWidth
                          onClick={() => window.open(details?.reject_file, "_blank")}
                        >
                          View Attached File (PDF)
                        </Button>
                      ) : (
                        <Box
                          component="img"
                          src={details?.reject_file}
                          onClick={() => window.open(details?.reject_file, "_blank")}
                          sx={{
                            width: 120,
                            height: 120,
                            borderRadius: 1,
                            border: '1px solid #ccc',
                            cursor: 'pointer',
                            objectFit: 'cover'
                          }}
                        />
                      )
                    )}
                  </Box>
                </Stack>
              ) : ''}
            </Box>
              </Grid>
            </Grid>
          ) : (
            <>
              <HeaderBreadcrumbs heading={'Edit Job'} links={''} action={''} />
              <AddProject
                singleProjectData={singleProjectData}
                setRenderCards={setRenderCards}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                setAdd={setAdd}
              />
            </>
          )}
          <Modal
            modalTitle={'Sales Order Details'}
            open={openInvoice === true}
            handleClose={() => setOpenInvoice(false)}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row', md: 'column' }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <Stack
                direction="row"
                justifyContent={'flex-end'}
                alignItems="center"
                spacing={1}
              >
                <ReactToPrint
                  trigger={() => (
                    <Button>
                      {' '}
                      <Print />
                      Print
                    </Button>
                  )}
                  content={() => componentRef.current}
                  copyStyles={false}
                  pageStyle={`
               @media print {
                 body {
                   font-size: 12pt
                 }
                 table {
                   width: 100%;
                   border-collapse: collapse;
                   margin-bottom: 10px;
                  
                 }
                .sales-order-heading-print {
                  text-align: center;
                  width: 100%;
                  position: absolute;
                  left: -60px;
                  top: -20px;
                }
     
                 th, td {
                   border: 1px solid #ddd;
                   padding: 8px;
                   text-align: left;
                 
                 }
               }
             `}
                />
                <div style={{ display: 'none' }}>
                  <PrintFunction
                    details={details}
                    invoice={invoice}
                    data1={data1}
                    ref={componentRef}
                  />
                </div>
                {/* <Button><Print />Print</Button> */}
              </Stack>
            </Stack>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Typography variant="body2">{COMPANY_NAME}</Typography>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data1?.company_website}</Typography>
                <Typography variant="body2">
                  {data1?.address}, {data1?.city}, {data1?.state},{' '}
                  {data1?.zipcode}
                </Typography>
                {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data1?.phone_country_code || data1?.phone) ? `+${data1?.phone_country_code}${data1?.phone}` : '951-682-9660'}</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data1?.company_fax_number ? `Fax: ${data1?.company_fax_number}` : ''}</Typography>
                </Box>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data1?.company_mail}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Typography variant="body2">
                  Order date:{' '}
                  {moment.unix(details?.timestamp).format('DD/MM/YYYY')}
                </Typography>
                {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
                {/* <Typography variant="body2">Order status:</Typography> */}
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={getStatusColorAndLabel(details?.status).color}
                >
                  {getStatusColorAndLabel(details?.status).label}
                </Label>
                {/* </Stack> */}
                <Typography variant="body2">Order ID: #{details?.doc_number}</Typography>
                <Typography variant="body2" sx={PRESERVE_WHITESPACE_SX}>
                  Job Name: {details?.name}
                </Typography>
                <Typography variant="body2">
                  Client Name: {customerData?.customer_name}
                </Typography>
                <Typography variant="body2">
                  Phone:{' '}
                  {customerData?.customer_phone &&
                    '+' + customerData?.customer_phone}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Scrollbar>
                <TableContainer sx={{ minWidth: 420 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>PRODUCT</TableCell>
                        <TableCell>UNIT PRICE</TableCell>
                        <TableCell>QTY</TableCell>
                        <TableCell>DISCOUNT</TableCell>
                        <TableCell>SUB TOTAL</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice?.cust_product?.map((val) => {
                        const {
                          vid,
                          product_name,
                          product_price,
                          quantity,
                          product_total,
                          discount,
                        } = val
                        return (
                          <TableRow
                            key={vid}
                            sx={{
                              borderBottom: (theme) =>
                                `solid 1px ${theme.palette.divider}`,
                            }}
                          >
                            <TableCell>{product_name}</TableCell>
                            <TableCell>{product_price}</TableCell>
                            <TableCell>{quantity}</TableCell>
                            <TableCell>{discount}</TableCell>
                            <TableCell>{product_total}</TableCell>
                          </TableRow>
                        )
                      })}

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">Subtotal</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">
                            {invoice?.sub_total}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">
                            Extra Discount
                          </Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">
                            {invoice?.extra_discount}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      {/* <RowResultStyle>
                    <TableCell colSpan={3} />
                    <TableCell align="center">
                      <Typography variant="overline">Total Discount</Typography>
                    </TableCell>
                    <TableCell align="center" width={10}>
                      <Typography variant="overline">$0</Typography>
                    </TableCell>
                    
                  </RowResultStyle> */}
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="subtitle1">Total</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="subtitle1">
                            {invoice?.total}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
              {/* </Card>   */}
            </Grid>
          </Modal>
          {/* this modal represent adding of attachments */}
          <Modal
            modalTitle={'Add Attachments'}
            open={openAttachModal}
            handleClose={() => setOpenAttachModal(false)}
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'flex-start'}
              spacing={{ xs: 2, sm: 3 }}
              mb={2}
            >
              <LoadingButton
                variant="outlined"
                size="small"
                sx={{ height: 40 }}
                onClick={() => fileInputRef.current.click()}
                loading={progress}
              >
                <UploadFileSharp /> Upload
              </LoadingButton>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                multiple
              />
            </Stack>
            <Box>
              <Scrollbar sx={{ width: '100%', height: 250 }}>
                <ImageList gap={8} cols={mdd ? 1 : xld ? 3 : 2}>
                  {attachments?.video &&
                    attachments.video.map((videoUrl, index) => (
                      <ImageListItem key={index}>
                        <ImageListItemBar
                          actionIcon={
                            <UserMoreMenu
                              onDelete={() =>
                                RemoveAttachFromSubmit('video', videoUrl)
                              }
                              noEdit
                            />
                          }
                        />
                        <video width="300" height="300" controls>
                          <source
                            src={`${videoUrl}?w=300&h=300&fit=crop&auto=format`}
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </ImageListItem>
                    ))}
                  {attachments?.other &&
                    attachments?.other.map((url, index) => {
                      const fileName = url?.split('/').pop()?.split('?')[0] || '';
                      const fileExt = fileName.split('.').pop()?.toLowerCase();
                      const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                      const isBrowserRenderable = ['svg','txt','html','htm'].includes(fileExt);
                      const googleViewerFormats = ['eps','ai','psd','tif','tiff','bmp','webp','ps','indd','indt'];
                      const canUseGoogleViewer = !isBrowserRenderable && googleViewerFormats.includes(fileExt);
                      
                      return (
                        <Card
                          key={index}
                          sx={{ p: 3, maxWidth: 368, mx: 'auto' }}
                        >
                          <Box sx={{ width: 300, height: 300, position: 'relative' }}>
                            {isOfficeFile ? (
                              <iframe
                                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
                                title={fileName}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                style={{ border: 'none' }}
                              />
                            ) : canUseGoogleViewer ? (
                              <>
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`}
                                  title={fileName}
                                  width="100%"
                                  height="100%"
                                  frameBorder="0"
                                  style={{ border: 'none' }}
                                />
                                <Box sx={{
                                  position: 'absolute', bottom: 6, left: '50%', transform: 'translateX(-50%)',
                                  backgroundColor: 'rgba(0,0,0,0.65)', borderRadius: '4px', px: 1, py: 0.25,
                                  pointerEvents: 'none'
                                }}>
                                  <Typography variant="caption" sx={{ color: '#fff', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 10 }}>
                                    .{fileExt}
                                  </Typography>
                                </Box>
                              </>
                            ) : (
                              <embed
                                src={url}
                                type={fileExt === 'pdf' ? "application/pdf" : undefined}
                                width="100%"
                                height="100%"
                              />
                            )}
                          </Box>
                          <UserMoreMenu
                            onDelete={() => RemoveAttachFromSubmit('other', url)}
                            noEdit
                          />
                        </Card>
                      );
                    })}
                  {attachments?.image &&
                    attachments.image.map((imageUrl, index) => (
                      <ImageListItem key={index}>
                        <img
                          srcSet={`${imageUrl}?w=248&fit=crop&auto=format&dpr=2 2x`}
                          src={`${imageUrl}?w=248&fit=crop&auto=format`}
                          loading="lazy"
                        />
                        <ImageListItemBar
                          actionIcon={
                            <UserMoreMenu
                              onDelete={() =>
                                RemoveAttachFromSubmit('image', imageUrl)
                              }
                              noEdit
                            />
                          }
                        />
                      </ImageListItem>
                    ))}
                </ImageList>
              </Scrollbar>
            </Box>
            <Box
              sx={{
                mt: 3,
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
              }}
            >
              <LoadingButton
                onClick={() => handleSubmitAttachments()}
                variant="contained"
                size="small"
              >
                Submit
              </LoadingButton>
              <Button
                variant="outlined"
                onClick={() => {
                  setAttachments({}), setOpenAttachModal(false)
                }}
                size="small"
              >
                Cancel
              </Button>
            </Box>
          </Modal>
          <AddTask
            coverImg={designs.length ? designs[0].name : ''}
            projectMembers={projectMembers}
            projectId={Number(id)}
            title={'Add Task'}
            add={add}
            requestId={details?.id}
            setIsOpen={setIsOpen}
            setAdd={setAdd}
            details={details}
            isTimeAndMaterial={details?.project_category === 12}
            onRefresh={() => {
              setRefresh(!refresh)
            }}
          />
          <AddMember
            allTeamMembers={allTeamMembers}
            projectId={Number(id)}
            prevProjectMembers={projectMembers}
            add={addMember}
            setIsOpen={setIsOpen}
            setAdd={setAddMember}
            onMembersAdded={handleMembersAdded}
            onRefresh={() => {
              setRefresh(!refresh)
            }}
          />
            <ConfirmationPopup
            open={reOpenJob}
            handleClick={() => handleReopenJob()}
            handleClose={() => setReOpenJob(false)}
            message={'You want to reopen this Job and sales order '}
          />
        </Container>
      )}
    </>
  )
}

const PrintFunction = forwardRef(({ details, invoice, data1 }, ref) => {
  const theme = useTheme()
  return (
    <Stack ref={ref}>
      <Grid container spacing={3} sx={{ position: 'relative' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', position: 'absolute', top: 0, left: 0, right: 0 }}>
          <Typography variant="h1" className="sales-order-heading-print">Invoice</Typography>
        </Box>
        <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
          <Typography variant="body2">{COMPANY_NAME}</Typography>
          <Typography variant="body2">www.{COMPANY_NAME}.com</Typography>
          <Typography variant="body2">
            {data1?.address}, {data1?.city}, {data1?.state}, {data1?.zipcode}
          </Typography>
          {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
          <Typography variant="body2">Telephone: {data1?.phone ? `+${data1?.phone_country_code}${data1?.phone}` : ''}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
          <Typography variant="body2">
            Order date: {moment.unix(details?.timestamp).format('DD/MM/YYYY')}
          </Typography>
          {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
          {/* <Typography variant="body2">Order status:</Typography> */}
          <Label
            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
            color={getStatusColorAndLabel(details?.status).color}
          >
            {getStatusColorAndLabel(details?.status).label}
          </Label>
          {/* </Stack> */}
          <Typography variant="body2">Order ID: #{details?.doc_number}</Typography>
          <Typography
            paragraph
            variant="overline"
            sx={{ color: 'text.disabled', marginTop: '20px' }}
          >
            TO {invoice?.customer_name}
          </Typography>
          <Typography variant="body2">
            Phone:{invoice?.customer_phone}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 420 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>PRODUCT</TableCell>
                  <TableCell>UNIT PRICE</TableCell>
                  <TableCell>QTY</TableCell>
                  <TableCell>DISCOUNT</TableCell>
                  <TableCell>SUB TOTAL</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice?.cust_product?.map((val) => {
                  const {
                    vid,
                    product_name,
                    product_price,
                    quantity,
                    product_total,
                    discount,
                  } = val
                  return (
                    <TableRow
                      key={vid}
                      sx={{
                        borderBottom: (theme) =>
                          `solid 1px ${theme.palette.divider}`,
                      }}
                    >
                      <TableCell>{product_name}</TableCell>
                      <TableCell>{product_price}</TableCell>
                      <TableCell>{quantity}</TableCell>
                      <TableCell>{discount}</TableCell>
                      <TableCell>{product_total}</TableCell>
                    </TableRow>
                  )
                })}

                <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="overline">Subtotal</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="overline">
                      {invoice?.sub_total}
                    </Typography>
                  </TableCell>
                </RowResultStyle>
                <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="overline">Extra Discount</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="overline">
                      {invoice?.extra_discount}
                    </Typography>
                  </TableCell>
                </RowResultStyle>
                {/* <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="overline">Total Discount</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="overline">$0</Typography>
                  </TableCell>
                </RowResultStyle> */}
                <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="subtitle1">Total</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="subtitle1">
                      {invoice?.total}
                    </Typography>
                  </TableCell>
                </RowResultStyle>
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
        {/* </Card>   */}
      </Grid>
    </Stack>
  )
})
